import e, { createContext as t, useState as n, useEffect as r, useContext as a, useRef as i } from "react";
function o(e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}
o(".__datepicker-modal-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 10001;\n  background-color: rgba(0, 0, 0, 0.425);\n}\n\n.__datepicker-dropdown {\n  width: 260px;\n  position: absolute;\n  box-shadow: 0 0 10px -2px rgba(0, 0, 0, 0.125);\n  padding: 5px;\n  background: var(--background);\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: var(--corner);\n  font-size: 12px;\n  z-index: 1000;\n  direction: ltr;\n}\n.__datepicker-dropdown.right-top {\n  bottom: 100%;\n  right: 0;\n}\n.__datepicker-dropdown.left-top {\n  bottom: 100%;\n  left: 0;\n}\n.__datepicker-dropdown.right-bottom {\n  right: 0;\n}\n.__datepicker-dropdown.left-bottom {\n  left: 0;\n}\n.__datepicker-dropdown.fix-top {\n  position: fixed;\n  top: 0;\n  right: unset;\n  bottom: unset;\n  left: unset;\n}\n.__datepicker-dropdown.__datepicker-modal {\n  position: fixed;\n  top: 50%;\n  right: 50%;\n  transform: translate3d(50%, -150px, 0);\n  z-index: 10002;\n}\n.__datepicker-dropdown * {\n  color: var(--color);\n  direction: ltr;\n}\n.__datepicker-dropdown .__datepicker-dropdown-footer {\n  border-top: var(--light-border);\n  padding: 5px 5px 0 0px;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n}\n.__datepicker-dropdown .__datepicker-dropdown-footer div {\n  margin-right: 10px;\n  border-radius: var(--corner);\n  padding: 3px 10px;\n}\n.__datepicker-dropdown .__datepicker-dropdown-footer div:hover {\n  background-color: var(--primary);\n}");
var _s = function s() {
  return _s = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var a in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, _s.apply(this, arguments);
};
function d(e, t, n) {
  if (n || 2 === arguments.length) for (var r, a = 0, i = t.length; a < i; a++) !r && a in t || (r || (r = Array.prototype.slice.call(t, 0, a)), r[a] = t[a]);
  return e.concat(r || Array.prototype.slice.call(t));
}
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function l(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var c,
  u = {
    exports: {}
  };
(c = u).exports = function () {
  var e, t;
  function n() {
    return e.apply(null, arguments);
  }
  function r(t) {
    e = t;
  }
  function a(e) {
    return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
  }
  function i(e) {
    return null != e && "[object Object]" === Object.prototype.toString.call(e);
  }
  function o(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }
  function s(e) {
    if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
    var t;
    for (t in e) if (o(e, t)) return !1;
    return !0;
  }
  function d(e) {
    return void 0 === e;
  }
  function u(e) {
    return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
  }
  function h(e) {
    return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
  }
  function f(e, t) {
    var n,
      r = [],
      a = e.length;
    for (n = 0; n < a; ++n) r.push(t(e[n], n));
    return r;
  }
  function _(e, t) {
    for (var n in t) o(t, n) && (e[n] = t[n]);
    return o(t, "toString") && (e.toString = t.toString), o(t, "valueOf") && (e.valueOf = t.valueOf), e;
  }
  function m(e, t, n, r) {
    return $n(e, t, n, r, !0).utc();
  }
  function p() {
    return {
      empty: !1,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: !1,
      invalidEra: null,
      invalidMonth: null,
      invalidFormat: !1,
      userInvalidated: !1,
      iso: !1,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: !1,
      weekdayMismatch: !1
    };
  }
  function y(e) {
    return null == e._pf && (e._pf = p()), e._pf;
  }
  function v(e) {
    if (null == e._isValid) {
      var n = y(e),
        r = t.call(n.parsedDateParts, function (e) {
          return null != e;
        }),
        a = !isNaN(e._d.getTime()) && n.overflow < 0 && !n.empty && !n.invalidEra && !n.invalidMonth && !n.invalidWeekday && !n.weekdayMismatch && !n.nullInput && !n.invalidFormat && !n.userInvalidated && (!n.meridiem || n.meridiem && r);
      if (e._strict && (a = a && 0 === n.charsLeftOver && 0 === n.unusedTokens.length && void 0 === n.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return a;
      e._isValid = a;
    }
    return e._isValid;
  }
  function g(e) {
    var t = m(NaN);
    return null != e ? _(y(t), e) : y(t).userInvalidated = !0, t;
  }
  t = Array.prototype.some ? Array.prototype.some : function (e) {
    var t,
      n = Object(this),
      r = n.length >>> 0;
    for (t = 0; t < r; t++) if (t in n && e.call(this, n[t], t, n)) return !0;
    return !1;
  };
  var k = n.momentProperties = [],
    b = !1;
  function w(e, t) {
    var n,
      r,
      a,
      i = k.length;
    if (d(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), d(t._i) || (e._i = t._i), d(t._f) || (e._f = t._f), d(t._l) || (e._l = t._l), d(t._strict) || (e._strict = t._strict), d(t._tzm) || (e._tzm = t._tzm), d(t._isUTC) || (e._isUTC = t._isUTC), d(t._offset) || (e._offset = t._offset), d(t._pf) || (e._pf = y(t)), d(t._locale) || (e._locale = t._locale), i > 0) for (n = 0; n < i; n++) d(a = t[r = k[n]]) || (e[r] = a);
    return e;
  }
  function Y(e) {
    w(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === b && (b = !0, n.updateOffset(this), b = !1);
  }
  function D(e) {
    return e instanceof Y || null != e && null != e._isAMomentObject;
  }
  function M(e) {
    !1 === n.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
  }
  function x(e, t) {
    var r = !0;
    return _(function () {
      if (null != n.deprecationHandler && n.deprecationHandler(null, e), r) {
        var a,
          i,
          s,
          d = [],
          l = arguments.length;
        for (i = 0; i < l; i++) {
          if (a = "", "object" == typeof arguments[i]) {
            for (s in a += "\n[" + i + "] ", arguments[0]) o(arguments[0], s) && (a += s + ": " + arguments[0][s] + ", ");
            a = a.slice(0, -2);
          } else a = arguments[i];
          d.push(a);
        }
        M(e + "\nArguments: " + Array.prototype.slice.call(d).join("") + "\n" + new Error().stack), r = !1;
      }
      return t.apply(this, arguments);
    }, t);
  }
  var S,
    N = {};
  function E(e, t) {
    null != n.deprecationHandler && n.deprecationHandler(e, t), N[e] || (M(t), N[e] = !0);
  }
  function O(e) {
    return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
  }
  function T(e) {
    var t, n;
    for (n in e) o(e, n) && (O(t = e[n]) ? this[n] = t : this["_" + n] = t);
    this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
  }
  function C(e, t) {
    var n,
      r = _({}, e);
    for (n in t) o(t, n) && (i(e[n]) && i(t[n]) ? (r[n] = {}, _(r[n], e[n]), _(r[n], t[n])) : null != t[n] ? r[n] = t[n] : delete r[n]);
    for (n in e) o(e, n) && !o(t, n) && i(e[n]) && (r[n] = _({}, r[n]));
    return r;
  }
  function W(e) {
    null != e && this.set(e);
  }
  n.suppressDeprecationWarnings = !1, n.deprecationHandler = null, S = Object.keys ? Object.keys : function (e) {
    var t,
      n = [];
    for (t in e) o(e, t) && n.push(t);
    return n;
  };
  var P = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: "dddd [at] LT",
    lastDay: "[Yesterday at] LT",
    lastWeek: "[Last] dddd [at] LT",
    sameElse: "L"
  };
  function R(e, t, n) {
    var r = this._calendar[e] || this._calendar.sameElse;
    return O(r) ? r.call(t, n) : r;
  }
  function L(e, t, n) {
    var r = "" + Math.abs(e),
      a = t - r.length;
    return (e >= 0 ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, a)).toString().substr(1) + r;
  }
  var F = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    H = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    U = {},
    V = {};
  function j(e, t, n, r) {
    var a = r;
    "string" == typeof r && (a = function a() {
      return this[r]();
    }), e && (V[e] = a), t && (V[t[0]] = function () {
      return L(a.apply(this, arguments), t[1], t[2]);
    }), n && (V[n] = function () {
      return this.localeData().ordinal(a.apply(this, arguments), e);
    });
  }
  function A(e) {
    return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
  }
  function I(e) {
    var t,
      n,
      r = e.match(F);
    for (t = 0, n = r.length; t < n; t++) V[r[t]] ? r[t] = V[r[t]] : r[t] = A(r[t]);
    return function (t) {
      var a,
        i = "";
      for (a = 0; a < n; a++) i += O(r[a]) ? r[a].call(t, e) : r[a];
      return i;
    };
  }
  function G(e, t) {
    return e.isValid() ? (t = z(t, e.localeData()), U[t] = U[t] || I(t), U[t](e)) : e.localeData().invalidDate();
  }
  function z(e, t) {
    var n = 5;
    function r(e) {
      return t.longDateFormat(e) || e;
    }
    for (H.lastIndex = 0; n >= 0 && H.test(e);) e = e.replace(H, r), H.lastIndex = 0, n -= 1;
    return e;
  }
  var Z = {
    LTS: "h:mm:ss A",
    LT: "h:mm A",
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A"
  };
  function B(e) {
    var t = this._longDateFormat[e],
      n = this._longDateFormat[e.toUpperCase()];
    return t || !n ? t : (this._longDateFormat[e] = n.match(F).map(function (e) {
      return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
    }).join(""), this._longDateFormat[e]);
  }
  var q = "Invalid date";
  function $() {
    return this._invalidDate;
  }
  var J = "%d",
    X = /\d{1,2}/;
  function Q(e) {
    return this._ordinal.replace("%d", e);
  }
  var K = {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    ss: "%d seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    w: "a week",
    ww: "%d weeks",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  };
  function ee(e, t, n, r) {
    var a = this._relativeTime[n];
    return O(a) ? a(e, t, n, r) : a.replace(/%d/i, e);
  }
  function te(e, t) {
    var n = this._relativeTime[e > 0 ? "future" : "past"];
    return O(n) ? n(t) : n.replace(/%s/i, t);
  }
  var ne = {};
  function re(e, t) {
    var n = e.toLowerCase();
    ne[n] = ne[n + "s"] = ne[t] = e;
  }
  function ae(e) {
    return "string" == typeof e ? ne[e] || ne[e.toLowerCase()] : void 0;
  }
  function ie(e) {
    var t,
      n,
      r = {};
    for (n in e) o(e, n) && (t = ae(n)) && (r[t] = e[n]);
    return r;
  }
  var oe = {};
  function se(e, t) {
    oe[e] = t;
  }
  function de(e) {
    var t,
      n = [];
    for (t in e) o(e, t) && n.push({
      unit: t,
      priority: oe[t]
    });
    return n.sort(function (e, t) {
      return e.priority - t.priority;
    }), n;
  }
  function le(e) {
    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
  }
  function ce(e) {
    return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
  }
  function ue(e) {
    var t = +e,
      n = 0;
    return 0 !== t && isFinite(t) && (n = ce(t)), n;
  }
  function he(e, t) {
    return function (r) {
      return null != r ? (_e(this, e, r), n.updateOffset(this, t), this) : fe(this, e);
    };
  }
  function fe(e, t) {
    return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
  }
  function _e(e, t, n) {
    e.isValid() && !isNaN(n) && ("FullYear" === t && le(e.year()) && 1 === e.month() && 29 === e.date() ? (n = ue(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), et(n, e.month()))) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
  }
  function me(e) {
    return O(this[e = ae(e)]) ? this[e]() : this;
  }
  function pe(e, t) {
    if ("object" == typeof e) {
      var n,
        r = de(e = ie(e)),
        a = r.length;
      for (n = 0; n < a; n++) this[r[n].unit](e[r[n].unit]);
    } else if (O(this[e = ae(e)])) return this[e](t);
    return this;
  }
  var ye,
    ve = /\d/,
    ge = /\d\d/,
    ke = /\d{3}/,
    be = /\d{4}/,
    we = /[+-]?\d{6}/,
    Ye = /\d\d?/,
    De = /\d\d\d\d?/,
    Me = /\d\d\d\d\d\d?/,
    xe = /\d{1,3}/,
    Se = /\d{1,4}/,
    Ne = /[+-]?\d{1,6}/,
    Ee = /\d+/,
    Oe = /[+-]?\d+/,
    Te = /Z|[+-]\d\d:?\d\d/gi,
    Ce = /Z|[+-]\d\d(?::?\d\d)?/gi,
    We = /[+-]?\d+(\.\d{1,3})?/,
    Pe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
  function Re(e, t, n) {
    ye[e] = O(t) ? t : function (e, r) {
      return e && n ? n : t;
    };
  }
  function Le(e, t) {
    return o(ye, e) ? ye[e](t._strict, t._locale) : new RegExp(Fe(e));
  }
  function Fe(e) {
    return He(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, r, a) {
      return t || n || r || a;
    }));
  }
  function He(e) {
    return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  ye = {};
  var Ue = {};
  function Ve(e, t) {
    var n,
      r,
      a = t;
    for ("string" == typeof e && (e = [e]), u(t) && (a = function a(e, n) {
      n[t] = ue(e);
    }), r = e.length, n = 0; n < r; n++) Ue[e[n]] = a;
  }
  function je(e, t) {
    Ve(e, function (e, n, r, a) {
      r._w = r._w || {}, t(e, r._w, r, a);
    });
  }
  function Ae(e, t, n) {
    null != t && o(Ue, e) && Ue[e](t, n._a, n, e);
  }
  var Ie,
    Ge = 0,
    ze = 1,
    Ze = 2,
    Be = 3,
    qe = 4,
    $e = 5,
    Je = 6,
    Xe = 7,
    Qe = 8;
  function Ke(e, t) {
    return (e % t + t) % t;
  }
  function et(e, t) {
    if (isNaN(e) || isNaN(t)) return NaN;
    var n = Ke(t, 12);
    return e += (t - n) / 12, 1 === n ? le(e) ? 29 : 28 : 31 - n % 7 % 2;
  }
  Ie = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
    var t;
    for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
    return -1;
  }, j("M", ["MM", 2], "Mo", function () {
    return this.month() + 1;
  }), j("MMM", 0, 0, function (e) {
    return this.localeData().monthsShort(this, e);
  }), j("MMMM", 0, 0, function (e) {
    return this.localeData().months(this, e);
  }), re("month", "M"), se("month", 8), Re("M", Ye), Re("MM", Ye, ge), Re("MMM", function (e, t) {
    return t.monthsShortRegex(e);
  }), Re("MMMM", function (e, t) {
    return t.monthsRegex(e);
  }), Ve(["M", "MM"], function (e, t) {
    t[ze] = ue(e) - 1;
  }), Ve(["MMM", "MMMM"], function (e, t, n, r) {
    var a = n._locale.monthsParse(e, r, n._strict);
    null != a ? t[ze] = a : y(n).invalidMonth = e;
  });
  var tt = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    nt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    rt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    at = Pe,
    it = Pe;
  function ot(e, t) {
    return e ? a(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || rt).test(t) ? "format" : "standalone"][e.month()] : a(this._months) ? this._months : this._months.standalone;
  }
  function st(e, t) {
    return e ? a(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[rt.test(t) ? "format" : "standalone"][e.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
  }
  function dt(e, t, n) {
    var r,
      a,
      i,
      o = e.toLocaleLowerCase();
    if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r) i = m([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(i, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(i, "").toLocaleLowerCase();
    return n ? "MMM" === t ? -1 !== (a = Ie.call(this._shortMonthsParse, o)) ? a : null : -1 !== (a = Ie.call(this._longMonthsParse, o)) ? a : null : "MMM" === t ? -1 !== (a = Ie.call(this._shortMonthsParse, o)) || -1 !== (a = Ie.call(this._longMonthsParse, o)) ? a : null : -1 !== (a = Ie.call(this._longMonthsParse, o)) || -1 !== (a = Ie.call(this._shortMonthsParse, o)) ? a : null;
  }
  function lt(e, t, n) {
    var r, a, i;
    if (this._monthsParseExact) return dt.call(this, e, t, n);
    for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
      if (a = m([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(a, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(a, "").replace(".", "") + "$", "i")), n || this._monthsParse[r] || (i = "^" + this.months(a, "") + "|^" + this.monthsShort(a, ""), this._monthsParse[r] = new RegExp(i.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[r].test(e)) return r;
      if (n && "MMM" === t && this._shortMonthsParse[r].test(e)) return r;
      if (!n && this._monthsParse[r].test(e)) return r;
    }
  }
  function ct(e, t) {
    var n;
    if (!e.isValid()) return e;
    if ("string" == typeof t) if (/^\d+$/.test(t)) t = ue(t);else if (!u(t = e.localeData().monthsParse(t))) return e;
    return n = Math.min(e.date(), et(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
  }
  function ut(e) {
    return null != e ? (ct(this, e), n.updateOffset(this, !0), this) : fe(this, "Month");
  }
  function ht() {
    return et(this.year(), this.month());
  }
  function ft(e) {
    return this._monthsParseExact ? (o(this, "_monthsRegex") || mt.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = at), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
  }
  function _t(e) {
    return this._monthsParseExact ? (o(this, "_monthsRegex") || mt.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (o(this, "_monthsRegex") || (this._monthsRegex = it), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
  }
  function mt() {
    function e(e, t) {
      return t.length - e.length;
    }
    var t,
      n,
      r = [],
      a = [],
      i = [];
    for (t = 0; t < 12; t++) n = m([2e3, t]), r.push(this.monthsShort(n, "")), a.push(this.months(n, "")), i.push(this.months(n, "")), i.push(this.monthsShort(n, ""));
    for (r.sort(e), a.sort(e), i.sort(e), t = 0; t < 12; t++) r[t] = He(r[t]), a[t] = He(a[t]);
    for (t = 0; t < 24; t++) i[t] = He(i[t]);
    this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i");
  }
  function pt(e) {
    return le(e) ? 366 : 365;
  }
  j("Y", 0, 0, function () {
    var e = this.year();
    return e <= 9999 ? L(e, 4) : "+" + e;
  }), j(0, ["YY", 2], 0, function () {
    return this.year() % 100;
  }), j(0, ["YYYY", 4], 0, "year"), j(0, ["YYYYY", 5], 0, "year"), j(0, ["YYYYYY", 6, !0], 0, "year"), re("year", "y"), se("year", 1), Re("Y", Oe), Re("YY", Ye, ge), Re("YYYY", Se, be), Re("YYYYY", Ne, we), Re("YYYYYY", Ne, we), Ve(["YYYYY", "YYYYYY"], Ge), Ve("YYYY", function (e, t) {
    t[Ge] = 2 === e.length ? n.parseTwoDigitYear(e) : ue(e);
  }), Ve("YY", function (e, t) {
    t[Ge] = n.parseTwoDigitYear(e);
  }), Ve("Y", function (e, t) {
    t[Ge] = parseInt(e, 10);
  }), n.parseTwoDigitYear = function (e) {
    return ue(e) + (ue(e) > 68 ? 1900 : 2e3);
  };
  var yt = he("FullYear", !0);
  function vt() {
    return le(this.year());
  }
  function gt(e, t, n, r, a, i, o) {
    var s;
    return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, r, a, i, o), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, r, a, i, o), s;
  }
  function kt(e) {
    var t, n;
    return e < 100 && e >= 0 ? ((n = Array.prototype.slice.call(arguments))[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
  }
  function bt(e, t, n) {
    var r = 7 + t - n;
    return -(7 + kt(e, 0, r).getUTCDay() - t) % 7 + r - 1;
  }
  function wt(e, t, n, r, a) {
    var i,
      o,
      s = 1 + 7 * (t - 1) + (7 + n - r) % 7 + bt(e, r, a);
    return s <= 0 ? o = pt(i = e - 1) + s : s > pt(e) ? (i = e + 1, o = s - pt(e)) : (i = e, o = s), {
      year: i,
      dayOfYear: o
    };
  }
  function Yt(e, t, n) {
    var r,
      a,
      i = bt(e.year(), t, n),
      o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1;
    return o < 1 ? r = o + Dt(a = e.year() - 1, t, n) : o > Dt(e.year(), t, n) ? (r = o - Dt(e.year(), t, n), a = e.year() + 1) : (a = e.year(), r = o), {
      week: r,
      year: a
    };
  }
  function Dt(e, t, n) {
    var r = bt(e, t, n),
      a = bt(e + 1, t, n);
    return (pt(e) - r + a) / 7;
  }
  function Mt(e) {
    return Yt(e, this._week.dow, this._week.doy).week;
  }
  j("w", ["ww", 2], "wo", "week"), j("W", ["WW", 2], "Wo", "isoWeek"), re("week", "w"), re("isoWeek", "W"), se("week", 5), se("isoWeek", 5), Re("w", Ye), Re("ww", Ye, ge), Re("W", Ye), Re("WW", Ye, ge), je(["w", "ww", "W", "WW"], function (e, t, n, r) {
    t[r.substr(0, 1)] = ue(e);
  });
  var xt = {
    dow: 0,
    doy: 6
  };
  function St() {
    return this._week.dow;
  }
  function Nt() {
    return this._week.doy;
  }
  function Et(e) {
    var t = this.localeData().week(this);
    return null == e ? t : this.add(7 * (e - t), "d");
  }
  function Ot(e) {
    var t = Yt(this, 1, 4).week;
    return null == e ? t : this.add(7 * (e - t), "d");
  }
  function Tt(e, t) {
    return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
  }
  function Ct(e, t) {
    return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
  }
  function Wt(e, t) {
    return e.slice(t, 7).concat(e.slice(0, t));
  }
  j("d", 0, "do", "day"), j("dd", 0, 0, function (e) {
    return this.localeData().weekdaysMin(this, e);
  }), j("ddd", 0, 0, function (e) {
    return this.localeData().weekdaysShort(this, e);
  }), j("dddd", 0, 0, function (e) {
    return this.localeData().weekdays(this, e);
  }), j("e", 0, 0, "weekday"), j("E", 0, 0, "isoWeekday"), re("day", "d"), re("weekday", "e"), re("isoWeekday", "E"), se("day", 11), se("weekday", 11), se("isoWeekday", 11), Re("d", Ye), Re("e", Ye), Re("E", Ye), Re("dd", function (e, t) {
    return t.weekdaysMinRegex(e);
  }), Re("ddd", function (e, t) {
    return t.weekdaysShortRegex(e);
  }), Re("dddd", function (e, t) {
    return t.weekdaysRegex(e);
  }), je(["dd", "ddd", "dddd"], function (e, t, n, r) {
    var a = n._locale.weekdaysParse(e, r, n._strict);
    null != a ? t.d = a : y(n).invalidWeekday = e;
  }), je(["d", "e", "E"], function (e, t, n, r) {
    t[r] = ue(e);
  });
  var Pt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    Rt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    Lt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    Ft = Pe,
    Ht = Pe,
    Ut = Pe;
  function Vt(e, t) {
    var n = a(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
    return !0 === e ? Wt(n, this._week.dow) : e ? n[e.day()] : n;
  }
  function jt(e) {
    return !0 === e ? Wt(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
  }
  function At(e) {
    return !0 === e ? Wt(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
  }
  function It(e, t, n) {
    var r,
      a,
      i,
      o = e.toLocaleLowerCase();
    if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r) i = m([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(i, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(i, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(i, "").toLocaleLowerCase();
    return n ? "dddd" === t ? -1 !== (a = Ie.call(this._weekdaysParse, o)) ? a : null : "ddd" === t ? -1 !== (a = Ie.call(this._shortWeekdaysParse, o)) ? a : null : -1 !== (a = Ie.call(this._minWeekdaysParse, o)) ? a : null : "dddd" === t ? -1 !== (a = Ie.call(this._weekdaysParse, o)) || -1 !== (a = Ie.call(this._shortWeekdaysParse, o)) || -1 !== (a = Ie.call(this._minWeekdaysParse, o)) ? a : null : "ddd" === t ? -1 !== (a = Ie.call(this._shortWeekdaysParse, o)) || -1 !== (a = Ie.call(this._weekdaysParse, o)) || -1 !== (a = Ie.call(this._minWeekdaysParse, o)) ? a : null : -1 !== (a = Ie.call(this._minWeekdaysParse, o)) || -1 !== (a = Ie.call(this._weekdaysParse, o)) || -1 !== (a = Ie.call(this._shortWeekdaysParse, o)) ? a : null;
  }
  function Gt(e, t, n) {
    var r, a, i;
    if (this._weekdaysParseExact) return It.call(this, e, t, n);
    for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
      if (a = m([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(a, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (i = "^" + this.weekdays(a, "") + "|^" + this.weekdaysShort(a, "") + "|^" + this.weekdaysMin(a, ""), this._weekdaysParse[r] = new RegExp(i.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[r].test(e)) return r;
      if (n && "ddd" === t && this._shortWeekdaysParse[r].test(e)) return r;
      if (n && "dd" === t && this._minWeekdaysParse[r].test(e)) return r;
      if (!n && this._weekdaysParse[r].test(e)) return r;
    }
  }
  function zt(e) {
    if (!this.isValid()) return null != e ? this : NaN;
    var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    return null != e ? (e = Tt(e, this.localeData()), this.add(e - t, "d")) : t;
  }
  function Zt(e) {
    if (!this.isValid()) return null != e ? this : NaN;
    var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return null == e ? t : this.add(e - t, "d");
  }
  function Bt(e) {
    if (!this.isValid()) return null != e ? this : NaN;
    if (null != e) {
      var t = Ct(e, this.localeData());
      return this.day(this.day() % 7 ? t : t - 7);
    }
    return this.day() || 7;
  }
  function qt(e) {
    return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Xt.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = Ft), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
  }
  function $t(e) {
    return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Xt.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ht), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
  }
  function Jt(e) {
    return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Xt.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Ut), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
  }
  function Xt() {
    function e(e, t) {
      return t.length - e.length;
    }
    var t,
      n,
      r,
      a,
      i,
      o = [],
      s = [],
      d = [],
      l = [];
    for (t = 0; t < 7; t++) n = m([2e3, 1]).day(t), r = He(this.weekdaysMin(n, "")), a = He(this.weekdaysShort(n, "")), i = He(this.weekdays(n, "")), o.push(r), s.push(a), d.push(i), l.push(r), l.push(a), l.push(i);
    o.sort(e), s.sort(e), d.sort(e), l.sort(e), this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i");
  }
  function Qt() {
    return this.hours() % 12 || 12;
  }
  function Kt() {
    return this.hours() || 24;
  }
  function en(e, t) {
    j(e, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), t);
    });
  }
  function tn(e, t) {
    return t._meridiemParse;
  }
  function nn(e) {
    return "p" === (e + "").toLowerCase().charAt(0);
  }
  j("H", ["HH", 2], 0, "hour"), j("h", ["hh", 2], 0, Qt), j("k", ["kk", 2], 0, Kt), j("hmm", 0, 0, function () {
    return "" + Qt.apply(this) + L(this.minutes(), 2);
  }), j("hmmss", 0, 0, function () {
    return "" + Qt.apply(this) + L(this.minutes(), 2) + L(this.seconds(), 2);
  }), j("Hmm", 0, 0, function () {
    return "" + this.hours() + L(this.minutes(), 2);
  }), j("Hmmss", 0, 0, function () {
    return "" + this.hours() + L(this.minutes(), 2) + L(this.seconds(), 2);
  }), en("a", !0), en("A", !1), re("hour", "h"), se("hour", 13), Re("a", tn), Re("A", tn), Re("H", Ye), Re("h", Ye), Re("k", Ye), Re("HH", Ye, ge), Re("hh", Ye, ge), Re("kk", Ye, ge), Re("hmm", De), Re("hmmss", Me), Re("Hmm", De), Re("Hmmss", Me), Ve(["H", "HH"], Be), Ve(["k", "kk"], function (e, t, n) {
    var r = ue(e);
    t[Be] = 24 === r ? 0 : r;
  }), Ve(["a", "A"], function (e, t, n) {
    n._isPm = n._locale.isPM(e), n._meridiem = e;
  }), Ve(["h", "hh"], function (e, t, n) {
    t[Be] = ue(e), y(n).bigHour = !0;
  }), Ve("hmm", function (e, t, n) {
    var r = e.length - 2;
    t[Be] = ue(e.substr(0, r)), t[qe] = ue(e.substr(r)), y(n).bigHour = !0;
  }), Ve("hmmss", function (e, t, n) {
    var r = e.length - 4,
      a = e.length - 2;
    t[Be] = ue(e.substr(0, r)), t[qe] = ue(e.substr(r, 2)), t[$e] = ue(e.substr(a)), y(n).bigHour = !0;
  }), Ve("Hmm", function (e, t, n) {
    var r = e.length - 2;
    t[Be] = ue(e.substr(0, r)), t[qe] = ue(e.substr(r));
  }), Ve("Hmmss", function (e, t, n) {
    var r = e.length - 4,
      a = e.length - 2;
    t[Be] = ue(e.substr(0, r)), t[qe] = ue(e.substr(r, 2)), t[$e] = ue(e.substr(a));
  });
  var rn = /[ap]\.?m?\.?/i,
    an = he("Hours", !0);
  function on(e, t, n) {
    return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
  }
  var sn,
    dn = {
      calendar: P,
      longDateFormat: Z,
      invalidDate: q,
      ordinal: J,
      dayOfMonthOrdinalParse: X,
      relativeTime: K,
      months: tt,
      monthsShort: nt,
      week: xt,
      weekdays: Pt,
      weekdaysMin: Lt,
      weekdaysShort: Rt,
      meridiemParse: rn
    },
    ln = {},
    cn = {};
  function un(e, t) {
    var n,
      r = Math.min(e.length, t.length);
    for (n = 0; n < r; n += 1) if (e[n] !== t[n]) return n;
    return r;
  }
  function hn(e) {
    return e ? e.toLowerCase().replace("_", "-") : e;
  }
  function fn(e) {
    for (var t, n, r, a, i = 0; i < e.length;) {
      for (t = (a = hn(e[i]).split("-")).length, n = (n = hn(e[i + 1])) ? n.split("-") : null; t > 0;) {
        if (r = mn(a.slice(0, t).join("-"))) return r;
        if (n && n.length >= t && un(a, n) >= t - 1) break;
        t--;
      }
      i++;
    }
    return sn;
  }
  function _n(e) {
    return null != e.match("^[^/\\\\]*$");
  }
  function mn(e) {
    var t = null;
    if (void 0 === ln[e] && c && c.exports && _n(e)) try {
      t = sn._abbr, l("./locale/" + e), pn(t);
    } catch (t) {
      ln[e] = null;
    }
    return ln[e];
  }
  function pn(e, t) {
    var n;
    return e && ((n = d(t) ? gn(e) : yn(e, t)) ? sn = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), sn._abbr;
  }
  function yn(e, t) {
    if (null !== t) {
      var n,
        r = dn;
      if (t.abbr = e, null != ln[e]) E("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = ln[e]._config;else if (null != t.parentLocale) if (null != ln[t.parentLocale]) r = ln[t.parentLocale]._config;else {
        if (null == (n = mn(t.parentLocale))) return cn[t.parentLocale] || (cn[t.parentLocale] = []), cn[t.parentLocale].push({
          name: e,
          config: t
        }), null;
        r = n._config;
      }
      return ln[e] = new W(C(r, t)), cn[e] && cn[e].forEach(function (e) {
        yn(e.name, e.config);
      }), pn(e), ln[e];
    }
    return delete ln[e], null;
  }
  function vn(e, t) {
    if (null != t) {
      var n,
        r,
        a = dn;
      null != ln[e] && null != ln[e].parentLocale ? ln[e].set(C(ln[e]._config, t)) : (null != (r = mn(e)) && (a = r._config), t = C(a, t), null == r && (t.abbr = e), (n = new W(t)).parentLocale = ln[e], ln[e] = n), pn(e);
    } else null != ln[e] && (null != ln[e].parentLocale ? (ln[e] = ln[e].parentLocale, e === pn() && pn(e)) : null != ln[e] && delete ln[e]);
    return ln[e];
  }
  function gn(e) {
    var t;
    if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return sn;
    if (!a(e)) {
      if (t = mn(e)) return t;
      e = [e];
    }
    return fn(e);
  }
  function kn() {
    return S(ln);
  }
  function bn(e) {
    var t,
      n = e._a;
    return n && -2 === y(e).overflow && (t = n[ze] < 0 || n[ze] > 11 ? ze : n[Ze] < 1 || n[Ze] > et(n[Ge], n[ze]) ? Ze : n[Be] < 0 || n[Be] > 24 || 24 === n[Be] && (0 !== n[qe] || 0 !== n[$e] || 0 !== n[Je]) ? Be : n[qe] < 0 || n[qe] > 59 ? qe : n[$e] < 0 || n[$e] > 59 ? $e : n[Je] < 0 || n[Je] > 999 ? Je : -1, y(e)._overflowDayOfYear && (t < Ge || t > Ze) && (t = Ze), y(e)._overflowWeeks && -1 === t && (t = Xe), y(e)._overflowWeekday && -1 === t && (t = Qe), y(e).overflow = t), e;
  }
  var wn = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    Yn = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    Dn = /Z|[+-]\d\d(?::?\d\d)?/,
    Mn = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, !1], ["YYYY", /\d{4}/, !1]],
    xn = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
    Sn = /^\/?Date\((-?\d+)/i,
    Nn = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    En = {
      UT: 0,
      GMT: 0,
      EDT: -240,
      EST: -300,
      CDT: -300,
      CST: -360,
      MDT: -360,
      MST: -420,
      PDT: -420,
      PST: -480
    };
  function On(e) {
    var t,
      n,
      r,
      a,
      i,
      o,
      s = e._i,
      d = wn.exec(s) || Yn.exec(s),
      l = Mn.length,
      c = xn.length;
    if (d) {
      for (y(e).iso = !0, t = 0, n = l; t < n; t++) if (Mn[t][1].exec(d[1])) {
        a = Mn[t][0], r = !1 !== Mn[t][2];
        break;
      }
      if (null == a) return void (e._isValid = !1);
      if (d[3]) {
        for (t = 0, n = c; t < n; t++) if (xn[t][1].exec(d[3])) {
          i = (d[2] || " ") + xn[t][0];
          break;
        }
        if (null == i) return void (e._isValid = !1);
      }
      if (!r && null != i) return void (e._isValid = !1);
      if (d[4]) {
        if (!Dn.exec(d[4])) return void (e._isValid = !1);
        o = "Z";
      }
      e._f = a + (i || "") + (o || ""), An(e);
    } else e._isValid = !1;
  }
  function Tn(e, t, n, r, a, i) {
    var o = [Cn(e), nt.indexOf(t), parseInt(n, 10), parseInt(r, 10), parseInt(a, 10)];
    return i && o.push(parseInt(i, 10)), o;
  }
  function Cn(e) {
    var t = parseInt(e, 10);
    return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
  }
  function Wn(e) {
    return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
  }
  function Pn(e, t, n) {
    return !e || Rt.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() || (y(n).weekdayMismatch = !0, n._isValid = !1, !1);
  }
  function Rn(e, t, n) {
    if (e) return En[e];
    if (t) return 0;
    var r = parseInt(n, 10),
      a = r % 100;
    return (r - a) / 100 * 60 + a;
  }
  function Ln(e) {
    var t,
      n = Nn.exec(Wn(e._i));
    if (n) {
      if (t = Tn(n[4], n[3], n[2], n[5], n[6], n[7]), !Pn(n[1], t, e)) return;
      e._a = t, e._tzm = Rn(n[8], n[9], n[10]), e._d = kt.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), y(e).rfc2822 = !0;
    } else e._isValid = !1;
  }
  function Fn(e) {
    var t = Sn.exec(e._i);
    null === t ? (On(e), !1 === e._isValid && (delete e._isValid, Ln(e), !1 === e._isValid && (delete e._isValid, e._strict ? e._isValid = !1 : n.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
  }
  function Hn(e, t, n) {
    return null != e ? e : null != t ? t : n;
  }
  function Un(e) {
    var t = new Date(n.now());
    return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()];
  }
  function Vn(e) {
    var t,
      n,
      r,
      a,
      i,
      o = [];
    if (!e._d) {
      for (r = Un(e), e._w && null == e._a[Ze] && null == e._a[ze] && jn(e), null != e._dayOfYear && (i = Hn(e._a[Ge], r[Ge]), (e._dayOfYear > pt(i) || 0 === e._dayOfYear) && (y(e)._overflowDayOfYear = !0), n = kt(i, 0, e._dayOfYear), e._a[ze] = n.getUTCMonth(), e._a[Ze] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = o[t] = r[t];
      for (; t < 7; t++) e._a[t] = o[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
      24 === e._a[Be] && 0 === e._a[qe] && 0 === e._a[$e] && 0 === e._a[Je] && (e._nextDay = !0, e._a[Be] = 0), e._d = (e._useUTC ? kt : gt).apply(null, o), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Be] = 24), e._w && void 0 !== e._w.d && e._w.d !== a && (y(e).weekdayMismatch = !0);
    }
  }
  function jn(e) {
    var t, n, r, a, i, o, s, d, l;
    null != (t = e._w).GG || null != t.W || null != t.E ? (i = 1, o = 4, n = Hn(t.GG, e._a[Ge], Yt(Jn(), 1, 4).year), r = Hn(t.W, 1), ((a = Hn(t.E, 1)) < 1 || a > 7) && (d = !0)) : (i = e._locale._week.dow, o = e._locale._week.doy, l = Yt(Jn(), i, o), n = Hn(t.gg, e._a[Ge], l.year), r = Hn(t.w, l.week), null != t.d ? ((a = t.d) < 0 || a > 6) && (d = !0) : null != t.e ? (a = t.e + i, (t.e < 0 || t.e > 6) && (d = !0)) : a = i), r < 1 || r > Dt(n, i, o) ? y(e)._overflowWeeks = !0 : null != d ? y(e)._overflowWeekday = !0 : (s = wt(n, r, a, i, o), e._a[Ge] = s.year, e._dayOfYear = s.dayOfYear);
  }
  function An(e) {
    if (e._f !== n.ISO_8601) {
      if (e._f !== n.RFC_2822) {
        e._a = [], y(e).empty = !0;
        var t,
          r,
          a,
          i,
          o,
          s,
          d,
          l = "" + e._i,
          c = l.length,
          u = 0;
        for (d = (a = z(e._f, e._locale).match(F) || []).length, t = 0; t < d; t++) i = a[t], (r = (l.match(Le(i, e)) || [])[0]) && ((o = l.substr(0, l.indexOf(r))).length > 0 && y(e).unusedInput.push(o), l = l.slice(l.indexOf(r) + r.length), u += r.length), V[i] ? (r ? y(e).empty = !1 : y(e).unusedTokens.push(i), Ae(i, r, e)) : e._strict && !r && y(e).unusedTokens.push(i);
        y(e).charsLeftOver = c - u, l.length > 0 && y(e).unusedInput.push(l), e._a[Be] <= 12 && !0 === y(e).bigHour && e._a[Be] > 0 && (y(e).bigHour = void 0), y(e).parsedDateParts = e._a.slice(0), y(e).meridiem = e._meridiem, e._a[Be] = In(e._locale, e._a[Be], e._meridiem), null !== (s = y(e).era) && (e._a[Ge] = e._locale.erasConvertYear(s, e._a[Ge])), Vn(e), bn(e);
      } else Ln(e);
    } else On(e);
  }
  function In(e, t, n) {
    var r;
    return null == n ? t : null != e.meridiemHour ? e.meridiemHour(t, n) : null != e.isPM ? ((r = e.isPM(n)) && t < 12 && (t += 12), r || 12 !== t || (t = 0), t) : t;
  }
  function Gn(e) {
    var t,
      n,
      r,
      a,
      i,
      o,
      s = !1,
      d = e._f.length;
    if (0 === d) return y(e).invalidFormat = !0, void (e._d = new Date(NaN));
    for (a = 0; a < d; a++) i = 0, o = !1, t = w({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[a], An(t), v(t) && (o = !0), i += y(t).charsLeftOver, i += 10 * y(t).unusedTokens.length, y(t).score = i, s ? i < r && (r = i, n = t) : (null == r || i < r || o) && (r = i, n = t, o && (s = !0));
    _(e, n || t);
  }
  function zn(e) {
    if (!e._d) {
      var t = ie(e._i),
        n = void 0 === t.day ? t.date : t.day;
      e._a = f([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function (e) {
        return e && parseInt(e, 10);
      }), Vn(e);
    }
  }
  function Zn(e) {
    var t = new Y(bn(Bn(e)));
    return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
  }
  function Bn(e) {
    var t = e._i,
      n = e._f;
    return e._locale = e._locale || gn(e._l), null === t || void 0 === n && "" === t ? g({
      nullInput: !0
    }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), D(t) ? new Y(bn(t)) : (h(t) ? e._d = t : a(n) ? Gn(e) : n ? An(e) : qn(e), v(e) || (e._d = null), e));
  }
  function qn(e) {
    var t = e._i;
    d(t) ? e._d = new Date(n.now()) : h(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? Fn(e) : a(t) ? (e._a = f(t.slice(0), function (e) {
      return parseInt(e, 10);
    }), Vn(e)) : i(t) ? zn(e) : u(t) ? e._d = new Date(t) : n.createFromInputFallback(e);
  }
  function $n(e, t, n, r, o) {
    var d = {};
    return !0 !== t && !1 !== t || (r = t, t = void 0), !0 !== n && !1 !== n || (r = n, n = void 0), (i(e) && s(e) || a(e) && 0 === e.length) && (e = void 0), d._isAMomentObject = !0, d._useUTC = d._isUTC = o, d._l = n, d._i = e, d._f = t, d._strict = r, Zn(d);
  }
  function Jn(e, t, n, r) {
    return $n(e, t, n, r, !1);
  }
  n.createFromInputFallback = x("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
    e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
  }), n.ISO_8601 = function () {}, n.RFC_2822 = function () {};
  var Xn = x("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
      var e = Jn.apply(null, arguments);
      return this.isValid() && e.isValid() ? e < this ? this : e : g();
    }),
    Qn = x("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
      var e = Jn.apply(null, arguments);
      return this.isValid() && e.isValid() ? e > this ? this : e : g();
    });
  function Kn(e, t) {
    var n, r;
    if (1 === t.length && a(t[0]) && (t = t[0]), !t.length) return Jn();
    for (n = t[0], r = 1; r < t.length; ++r) t[r].isValid() && !t[r][e](n) || (n = t[r]);
    return n;
  }
  function er() {
    return Kn("isBefore", [].slice.call(arguments, 0));
  }
  function tr() {
    return Kn("isAfter", [].slice.call(arguments, 0));
  }
  var nr = function nr() {
      return Date.now ? Date.now() : +new Date();
    },
    rr = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
  function ar(e) {
    var t,
      n,
      r = !1,
      a = rr.length;
    for (t in e) if (o(e, t) && (-1 === Ie.call(rr, t) || null != e[t] && isNaN(e[t]))) return !1;
    for (n = 0; n < a; ++n) if (e[rr[n]]) {
      if (r) return !1;
      parseFloat(e[rr[n]]) !== ue(e[rr[n]]) && (r = !0);
    }
    return !0;
  }
  function ir() {
    return this._isValid;
  }
  function or() {
    return Er(NaN);
  }
  function sr(e) {
    var t = ie(e),
      n = t.year || 0,
      r = t.quarter || 0,
      a = t.month || 0,
      i = t.week || t.isoWeek || 0,
      o = t.day || 0,
      s = t.hour || 0,
      d = t.minute || 0,
      l = t.second || 0,
      c = t.millisecond || 0;
    this._isValid = ar(t), this._milliseconds = +c + 1e3 * l + 6e4 * d + 1e3 * s * 60 * 60, this._days = +o + 7 * i, this._months = +a + 3 * r + 12 * n, this._data = {}, this._locale = gn(), this._bubble();
  }
  function dr(e) {
    return e instanceof sr;
  }
  function lr(e) {
    return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
  }
  function cr(e, t, n) {
    var r,
      a = Math.min(e.length, t.length),
      i = Math.abs(e.length - t.length),
      o = 0;
    for (r = 0; r < a; r++) (n && e[r] !== t[r] || !n && ue(e[r]) !== ue(t[r])) && o++;
    return o + i;
  }
  function ur(e, t) {
    j(e, 0, 0, function () {
      var e = this.utcOffset(),
        n = "+";
      return e < 0 && (e = -e, n = "-"), n + L(~~(e / 60), 2) + t + L(~~e % 60, 2);
    });
  }
  ur("Z", ":"), ur("ZZ", ""), Re("Z", Ce), Re("ZZ", Ce), Ve(["Z", "ZZ"], function (e, t, n) {
    n._useUTC = !0, n._tzm = fr(Ce, e);
  });
  var hr = /([\+\-]|\d\d)/gi;
  function fr(e, t) {
    var n,
      r,
      a = (t || "").match(e);
    return null === a ? null : 0 === (r = 60 * (n = ((a[a.length - 1] || []) + "").match(hr) || ["-", 0, 0])[1] + ue(n[2])) ? 0 : "+" === n[0] ? r : -r;
  }
  function _r(e, t) {
    var r, a;
    return t._isUTC ? (r = t.clone(), a = (D(e) || h(e) ? e.valueOf() : Jn(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + a), n.updateOffset(r, !1), r) : Jn(e).local();
  }
  function mr(e) {
    return -Math.round(e._d.getTimezoneOffset());
  }
  function pr(e, t, r) {
    var a,
      i = this._offset || 0;
    if (!this.isValid()) return null != e ? this : NaN;
    if (null != e) {
      if ("string" == typeof e) {
        if (null === (e = fr(Ce, e))) return this;
      } else Math.abs(e) < 16 && !r && (e *= 60);
      return !this._isUTC && t && (a = mr(this)), this._offset = e, this._isUTC = !0, null != a && this.add(a, "m"), i !== e && (!t || this._changeInProgress ? Pr(this, Er(e - i, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, n.updateOffset(this, !0), this._changeInProgress = null)), this;
    }
    return this._isUTC ? i : mr(this);
  }
  function yr(e, t) {
    return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
  }
  function vr(e) {
    return this.utcOffset(0, e);
  }
  function gr(e) {
    return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(mr(this), "m")), this;
  }
  function kr() {
    if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
      var e = fr(Te, this._i);
      null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
    }
    return this;
  }
  function br(e) {
    return !!this.isValid() && (e = e ? Jn(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
  }
  function wr() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }
  function Yr() {
    if (!d(this._isDSTShifted)) return this._isDSTShifted;
    var e,
      t = {};
    return w(t, this), (t = Bn(t))._a ? (e = t._isUTC ? m(t._a) : Jn(t._a), this._isDSTShifted = this.isValid() && cr(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
  }
  function Dr() {
    return !!this.isValid() && !this._isUTC;
  }
  function Mr() {
    return !!this.isValid() && this._isUTC;
  }
  function xr() {
    return !!this.isValid() && this._isUTC && 0 === this._offset;
  }
  n.updateOffset = function () {};
  var Sr = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    Nr = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
  function Er(e, t) {
    var n,
      r,
      a,
      i = e,
      s = null;
    return dr(e) ? i = {
      ms: e._milliseconds,
      d: e._days,
      M: e._months
    } : u(e) || !isNaN(+e) ? (i = {}, t ? i[t] = +e : i.milliseconds = +e) : (s = Sr.exec(e)) ? (n = "-" === s[1] ? -1 : 1, i = {
      y: 0,
      d: ue(s[Ze]) * n,
      h: ue(s[Be]) * n,
      m: ue(s[qe]) * n,
      s: ue(s[$e]) * n,
      ms: ue(lr(1e3 * s[Je])) * n
    }) : (s = Nr.exec(e)) ? (n = "-" === s[1] ? -1 : 1, i = {
      y: Or(s[2], n),
      M: Or(s[3], n),
      w: Or(s[4], n),
      d: Or(s[5], n),
      h: Or(s[6], n),
      m: Or(s[7], n),
      s: Or(s[8], n)
    }) : null == i ? i = {} : "object" == typeof i && ("from" in i || "to" in i) && (a = Cr(Jn(i.from), Jn(i.to)), (i = {}).ms = a.milliseconds, i.M = a.months), r = new sr(i), dr(e) && o(e, "_locale") && (r._locale = e._locale), dr(e) && o(e, "_isValid") && (r._isValid = e._isValid), r;
  }
  function Or(e, t) {
    var n = e && parseFloat(e.replace(",", "."));
    return (isNaN(n) ? 0 : n) * t;
  }
  function Tr(e, t) {
    var n = {};
    return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
  }
  function Cr(e, t) {
    var n;
    return e.isValid() && t.isValid() ? (t = _r(t, e), e.isBefore(t) ? n = Tr(e, t) : ((n = Tr(t, e)).milliseconds = -n.milliseconds, n.months = -n.months), n) : {
      milliseconds: 0,
      months: 0
    };
  }
  function Wr(e, t) {
    return function (n, r) {
      var a;
      return null === r || isNaN(+r) || (E(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), a = n, n = r, r = a), Pr(this, Er(n, r), e), this;
    };
  }
  function Pr(e, t, r, a) {
    var i = t._milliseconds,
      o = lr(t._days),
      s = lr(t._months);
    e.isValid() && (a = null == a || a, s && ct(e, fe(e, "Month") + s * r), o && _e(e, "Date", fe(e, "Date") + o * r), i && e._d.setTime(e._d.valueOf() + i * r), a && n.updateOffset(e, o || s));
  }
  Er.fn = sr.prototype, Er.invalid = or;
  var Rr = Wr(1, "add"),
    Lr = Wr(-1, "subtract");
  function Fr(e) {
    return "string" == typeof e || e instanceof String;
  }
  function Hr(e) {
    return D(e) || h(e) || Fr(e) || u(e) || Vr(e) || Ur(e) || null == e;
  }
  function Ur(e) {
    var t,
      n,
      r = i(e) && !s(e),
      a = !1,
      d = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"],
      l = d.length;
    for (t = 0; t < l; t += 1) n = d[t], a = a || o(e, n);
    return r && a;
  }
  function Vr(e) {
    var t = a(e),
      n = !1;
    return t && (n = 0 === e.filter(function (t) {
      return !u(t) && Fr(e);
    }).length), t && n;
  }
  function jr(e) {
    var t,
      n,
      r = i(e) && !s(e),
      a = !1,
      d = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
    for (t = 0; t < d.length; t += 1) n = d[t], a = a || o(e, n);
    return r && a;
  }
  function Ar(e, t) {
    var n = e.diff(t, "days", !0);
    return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
  }
  function Ir(e, t) {
    1 === arguments.length && (arguments[0] ? Hr(arguments[0]) ? (e = arguments[0], t = void 0) : jr(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
    var r = e || Jn(),
      a = _r(r, this).startOf("day"),
      i = n.calendarFormat(this, a) || "sameElse",
      o = t && (O(t[i]) ? t[i].call(this, r) : t[i]);
    return this.format(o || this.localeData().calendar(i, this, Jn(r)));
  }
  function Gr() {
    return new Y(this);
  }
  function zr(e, t) {
    var n = D(e) ? e : Jn(e);
    return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = ae(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
  }
  function Zr(e, t) {
    var n = D(e) ? e : Jn(e);
    return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = ae(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
  }
  function Br(e, t, n, r) {
    var a = D(e) ? e : Jn(e),
      i = D(t) ? t : Jn(t);
    return !!(this.isValid() && a.isValid() && i.isValid()) && ("(" === (r = r || "()")[0] ? this.isAfter(a, n) : !this.isBefore(a, n)) && (")" === r[1] ? this.isBefore(i, n) : !this.isAfter(i, n));
  }
  function qr(e, t) {
    var n,
      r = D(e) ? e : Jn(e);
    return !(!this.isValid() || !r.isValid()) && ("millisecond" === (t = ae(t) || "millisecond") ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
  }
  function $r(e, t) {
    return this.isSame(e, t) || this.isAfter(e, t);
  }
  function Jr(e, t) {
    return this.isSame(e, t) || this.isBefore(e, t);
  }
  function Xr(e, t, n) {
    var r, a, i;
    if (!this.isValid()) return NaN;
    if (!(r = _r(e, this)).isValid()) return NaN;
    switch (a = 6e4 * (r.utcOffset() - this.utcOffset()), t = ae(t)) {
      case "year":
        i = Qr(this, r) / 12;
        break;
      case "month":
        i = Qr(this, r);
        break;
      case "quarter":
        i = Qr(this, r) / 3;
        break;
      case "second":
        i = (this - r) / 1e3;
        break;
      case "minute":
        i = (this - r) / 6e4;
        break;
      case "hour":
        i = (this - r) / 36e5;
        break;
      case "day":
        i = (this - r - a) / 864e5;
        break;
      case "week":
        i = (this - r - a) / 6048e5;
        break;
      default:
        i = this - r;
    }
    return n ? i : ce(i);
  }
  function Qr(e, t) {
    if (e.date() < t.date()) return -Qr(t, e);
    var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
      r = e.clone().add(n, "months");
    return -(n + (t - r < 0 ? (t - r) / (r - e.clone().add(n - 1, "months")) : (t - r) / (e.clone().add(n + 1, "months") - r))) || 0;
  }
  function Kr() {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  }
  function ea(e) {
    if (!this.isValid()) return null;
    var t = !0 !== e,
      n = t ? this.clone().utc() : this;
    return n.year() < 0 || n.year() > 9999 ? G(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : O(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", G(n, "Z")) : G(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
  }
  function ta() {
    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
    var e,
      t,
      n,
      r,
      a = "moment",
      i = "";
    return this.isLocal() || (a = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", i = "Z"), e = "[" + a + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", r = i + '[")]', this.format(e + t + n + r);
  }
  function na(e) {
    e || (e = this.isUtc() ? n.defaultFormatUtc : n.defaultFormat);
    var t = G(this, e);
    return this.localeData().postformat(t);
  }
  function ra(e, t) {
    return this.isValid() && (D(e) && e.isValid() || Jn(e).isValid()) ? Er({
      to: this,
      from: e
    }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
  }
  function aa(e) {
    return this.from(Jn(), e);
  }
  function ia(e, t) {
    return this.isValid() && (D(e) && e.isValid() || Jn(e).isValid()) ? Er({
      from: this,
      to: e
    }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
  }
  function oa(e) {
    return this.to(Jn(), e);
  }
  function sa(e) {
    var t;
    return void 0 === e ? this._locale._abbr : (null != (t = gn(e)) && (this._locale = t), this);
  }
  n.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", n.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
  var da = x("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
    return void 0 === e ? this.localeData() : this.locale(e);
  });
  function la() {
    return this._locale;
  }
  var ca = 1e3,
    ua = 60 * ca,
    ha = 60 * ua,
    fa = 3506328 * ha;
  function _a(e, t) {
    return (e % t + t) % t;
  }
  function ma(e, t, n) {
    return e < 100 && e >= 0 ? new Date(e + 400, t, n) - fa : new Date(e, t, n).valueOf();
  }
  function pa(e, t, n) {
    return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - fa : Date.UTC(e, t, n);
  }
  function ya(e) {
    var t, r;
    if (void 0 === (e = ae(e)) || "millisecond" === e || !this.isValid()) return this;
    switch (r = this._isUTC ? pa : ma, e) {
      case "year":
        t = r(this.year(), 0, 1);
        break;
      case "quarter":
        t = r(this.year(), this.month() - this.month() % 3, 1);
        break;
      case "month":
        t = r(this.year(), this.month(), 1);
        break;
      case "week":
        t = r(this.year(), this.month(), this.date() - this.weekday());
        break;
      case "isoWeek":
        t = r(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;
      case "day":
      case "date":
        t = r(this.year(), this.month(), this.date());
        break;
      case "hour":
        t = this._d.valueOf(), t -= _a(t + (this._isUTC ? 0 : this.utcOffset() * ua), ha);
        break;
      case "minute":
        t = this._d.valueOf(), t -= _a(t, ua);
        break;
      case "second":
        t = this._d.valueOf(), t -= _a(t, ca);
    }
    return this._d.setTime(t), n.updateOffset(this, !0), this;
  }
  function va(e) {
    var t, r;
    if (void 0 === (e = ae(e)) || "millisecond" === e || !this.isValid()) return this;
    switch (r = this._isUTC ? pa : ma, e) {
      case "year":
        t = r(this.year() + 1, 0, 1) - 1;
        break;
      case "quarter":
        t = r(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
        break;
      case "month":
        t = r(this.year(), this.month() + 1, 1) - 1;
        break;
      case "week":
        t = r(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;
      case "isoWeek":
        t = r(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
        break;
      case "day":
      case "date":
        t = r(this.year(), this.month(), this.date() + 1) - 1;
        break;
      case "hour":
        t = this._d.valueOf(), t += ha - _a(t + (this._isUTC ? 0 : this.utcOffset() * ua), ha) - 1;
        break;
      case "minute":
        t = this._d.valueOf(), t += ua - _a(t, ua) - 1;
        break;
      case "second":
        t = this._d.valueOf(), t += ca - _a(t, ca) - 1;
    }
    return this._d.setTime(t), n.updateOffset(this, !0), this;
  }
  function ga() {
    return this._d.valueOf() - 6e4 * (this._offset || 0);
  }
  function ka() {
    return Math.floor(this.valueOf() / 1e3);
  }
  function ba() {
    return new Date(this.valueOf());
  }
  function wa() {
    var e = this;
    return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
  }
  function Ya() {
    var e = this;
    return {
      years: e.year(),
      months: e.month(),
      date: e.date(),
      hours: e.hours(),
      minutes: e.minutes(),
      seconds: e.seconds(),
      milliseconds: e.milliseconds()
    };
  }
  function Da() {
    return this.isValid() ? this.toISOString() : null;
  }
  function Ma() {
    return v(this);
  }
  function xa() {
    return _({}, y(this));
  }
  function Sa() {
    return y(this).overflow;
  }
  function Na() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }
  function Ea(e, t) {
    var r,
      a,
      i,
      o = this._eras || gn("en")._eras;
    for (r = 0, a = o.length; r < a; ++r) switch ("string" == typeof o[r].since && (i = n(o[r].since).startOf("day"), o[r].since = i.valueOf()), typeof o[r].until) {
      case "undefined":
        o[r].until = 1 / 0;
        break;
      case "string":
        i = n(o[r].until).startOf("day").valueOf(), o[r].until = i.valueOf();
    }
    return o;
  }
  function Oa(e, t, n) {
    var r,
      a,
      i,
      o,
      s,
      d = this.eras();
    for (e = e.toUpperCase(), r = 0, a = d.length; r < a; ++r) if (i = d[r].name.toUpperCase(), o = d[r].abbr.toUpperCase(), s = d[r].narrow.toUpperCase(), n) switch (t) {
      case "N":
      case "NN":
      case "NNN":
        if (o === e) return d[r];
        break;
      case "NNNN":
        if (i === e) return d[r];
        break;
      case "NNNNN":
        if (s === e) return d[r];
    } else if ([i, o, s].indexOf(e) >= 0) return d[r];
  }
  function Ta(e, t) {
    var r = e.since <= e.until ? 1 : -1;
    return void 0 === t ? n(e.since).year() : n(e.since).year() + (t - e.offset) * r;
  }
  function Ca() {
    var e,
      t,
      n,
      r = this.localeData().eras();
    for (e = 0, t = r.length; e < t; ++e) {
      if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until) return r[e].name;
      if (r[e].until <= n && n <= r[e].since) return r[e].name;
    }
    return "";
  }
  function Wa() {
    var e,
      t,
      n,
      r = this.localeData().eras();
    for (e = 0, t = r.length; e < t; ++e) {
      if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until) return r[e].narrow;
      if (r[e].until <= n && n <= r[e].since) return r[e].narrow;
    }
    return "";
  }
  function Pa() {
    var e,
      t,
      n,
      r = this.localeData().eras();
    for (e = 0, t = r.length; e < t; ++e) {
      if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until) return r[e].abbr;
      if (r[e].until <= n && n <= r[e].since) return r[e].abbr;
    }
    return "";
  }
  function Ra() {
    var e,
      t,
      r,
      a,
      i = this.localeData().eras();
    for (e = 0, t = i.length; e < t; ++e) if (r = i[e].since <= i[e].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since) return (this.year() - n(i[e].since).year()) * r + i[e].offset;
    return this.year();
  }
  function La(e) {
    return o(this, "_erasNameRegex") || Ia.call(this), e ? this._erasNameRegex : this._erasRegex;
  }
  function Fa(e) {
    return o(this, "_erasAbbrRegex") || Ia.call(this), e ? this._erasAbbrRegex : this._erasRegex;
  }
  function Ha(e) {
    return o(this, "_erasNarrowRegex") || Ia.call(this), e ? this._erasNarrowRegex : this._erasRegex;
  }
  function Ua(e, t) {
    return t.erasAbbrRegex(e);
  }
  function Va(e, t) {
    return t.erasNameRegex(e);
  }
  function ja(e, t) {
    return t.erasNarrowRegex(e);
  }
  function Aa(e, t) {
    return t._eraYearOrdinalRegex || Ee;
  }
  function Ia() {
    var e,
      t,
      n = [],
      r = [],
      a = [],
      i = [],
      o = this.eras();
    for (e = 0, t = o.length; e < t; ++e) r.push(He(o[e].name)), n.push(He(o[e].abbr)), a.push(He(o[e].narrow)), i.push(He(o[e].name)), i.push(He(o[e].abbr)), i.push(He(o[e].narrow));
    this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + a.join("|") + ")", "i");
  }
  function Ga(e, t) {
    j(0, [e, e.length], 0, t);
  }
  function za(e) {
    return Xa.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }
  function Za(e) {
    return Xa.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
  }
  function Ba() {
    return Dt(this.year(), 1, 4);
  }
  function qa() {
    return Dt(this.isoWeekYear(), 1, 4);
  }
  function $a() {
    var e = this.localeData()._week;
    return Dt(this.year(), e.dow, e.doy);
  }
  function Ja() {
    var e = this.localeData()._week;
    return Dt(this.weekYear(), e.dow, e.doy);
  }
  function Xa(e, t, n, r, a) {
    var i;
    return null == e ? Yt(this, r, a).year : (t > (i = Dt(e, r, a)) && (t = i), Qa.call(this, e, t, n, r, a));
  }
  function Qa(e, t, n, r, a) {
    var i = wt(e, t, n, r, a),
      o = kt(i.year, 0, i.dayOfYear);
    return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
  }
  function Ka(e) {
    return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
  }
  j("N", 0, 0, "eraAbbr"), j("NN", 0, 0, "eraAbbr"), j("NNN", 0, 0, "eraAbbr"), j("NNNN", 0, 0, "eraName"), j("NNNNN", 0, 0, "eraNarrow"), j("y", ["y", 1], "yo", "eraYear"), j("y", ["yy", 2], 0, "eraYear"), j("y", ["yyy", 3], 0, "eraYear"), j("y", ["yyyy", 4], 0, "eraYear"), Re("N", Ua), Re("NN", Ua), Re("NNN", Ua), Re("NNNN", Va), Re("NNNNN", ja), Ve(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, n, r) {
    var a = n._locale.erasParse(e, r, n._strict);
    a ? y(n).era = a : y(n).invalidEra = e;
  }), Re("y", Ee), Re("yy", Ee), Re("yyy", Ee), Re("yyyy", Ee), Re("yo", Aa), Ve(["y", "yy", "yyy", "yyyy"], Ge), Ve(["yo"], function (e, t, n, r) {
    var a;
    n._locale._eraYearOrdinalRegex && (a = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[Ge] = n._locale.eraYearOrdinalParse(e, a) : t[Ge] = parseInt(e, 10);
  }), j(0, ["gg", 2], 0, function () {
    return this.weekYear() % 100;
  }), j(0, ["GG", 2], 0, function () {
    return this.isoWeekYear() % 100;
  }), Ga("gggg", "weekYear"), Ga("ggggg", "weekYear"), Ga("GGGG", "isoWeekYear"), Ga("GGGGG", "isoWeekYear"), re("weekYear", "gg"), re("isoWeekYear", "GG"), se("weekYear", 1), se("isoWeekYear", 1), Re("G", Oe), Re("g", Oe), Re("GG", Ye, ge), Re("gg", Ye, ge), Re("GGGG", Se, be), Re("gggg", Se, be), Re("GGGGG", Ne, we), Re("ggggg", Ne, we), je(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, r) {
    t[r.substr(0, 2)] = ue(e);
  }), je(["gg", "GG"], function (e, t, r, a) {
    t[a] = n.parseTwoDigitYear(e);
  }), j("Q", 0, "Qo", "quarter"), re("quarter", "Q"), se("quarter", 7), Re("Q", ve), Ve("Q", function (e, t) {
    t[ze] = 3 * (ue(e) - 1);
  }), j("D", ["DD", 2], "Do", "date"), re("date", "D"), se("date", 9), Re("D", Ye), Re("DD", Ye, ge), Re("Do", function (e, t) {
    return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
  }), Ve(["D", "DD"], Ze), Ve("Do", function (e, t) {
    t[Ze] = ue(e.match(Ye)[0]);
  });
  var ei = he("Date", !0);
  function ti(e) {
    var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
    return null == e ? t : this.add(e - t, "d");
  }
  j("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), re("dayOfYear", "DDD"), se("dayOfYear", 4), Re("DDD", xe), Re("DDDD", ke), Ve(["DDD", "DDDD"], function (e, t, n) {
    n._dayOfYear = ue(e);
  }), j("m", ["mm", 2], 0, "minute"), re("minute", "m"), se("minute", 14), Re("m", Ye), Re("mm", Ye, ge), Ve(["m", "mm"], qe);
  var ni = he("Minutes", !1);
  j("s", ["ss", 2], 0, "second"), re("second", "s"), se("second", 15), Re("s", Ye), Re("ss", Ye, ge), Ve(["s", "ss"], $e);
  var ri,
    ai,
    ii = he("Seconds", !1);
  for (j("S", 0, 0, function () {
    return ~~(this.millisecond() / 100);
  }), j(0, ["SS", 2], 0, function () {
    return ~~(this.millisecond() / 10);
  }), j(0, ["SSS", 3], 0, "millisecond"), j(0, ["SSSS", 4], 0, function () {
    return 10 * this.millisecond();
  }), j(0, ["SSSSS", 5], 0, function () {
    return 100 * this.millisecond();
  }), j(0, ["SSSSSS", 6], 0, function () {
    return 1e3 * this.millisecond();
  }), j(0, ["SSSSSSS", 7], 0, function () {
    return 1e4 * this.millisecond();
  }), j(0, ["SSSSSSSS", 8], 0, function () {
    return 1e5 * this.millisecond();
  }), j(0, ["SSSSSSSSS", 9], 0, function () {
    return 1e6 * this.millisecond();
  }), re("millisecond", "ms"), se("millisecond", 16), Re("S", xe, ve), Re("SS", xe, ge), Re("SSS", xe, ke), ri = "SSSS"; ri.length <= 9; ri += "S") Re(ri, Ee);
  function oi(e, t) {
    t[Je] = ue(1e3 * ("0." + e));
  }
  for (ri = "S"; ri.length <= 9; ri += "S") Ve(ri, oi);
  function si() {
    return this._isUTC ? "UTC" : "";
  }
  function di() {
    return this._isUTC ? "Coordinated Universal Time" : "";
  }
  ai = he("Milliseconds", !1), j("z", 0, 0, "zoneAbbr"), j("zz", 0, 0, "zoneName");
  var li = Y.prototype;
  function ci(e) {
    return Jn(1e3 * e);
  }
  function ui() {
    return Jn.apply(null, arguments).parseZone();
  }
  function hi(e) {
    return e;
  }
  li.add = Rr, li.calendar = Ir, li.clone = Gr, li.diff = Xr, li.endOf = va, li.format = na, li.from = ra, li.fromNow = aa, li.to = ia, li.toNow = oa, li.get = me, li.invalidAt = Sa, li.isAfter = zr, li.isBefore = Zr, li.isBetween = Br, li.isSame = qr, li.isSameOrAfter = $r, li.isSameOrBefore = Jr, li.isValid = Ma, li.lang = da, li.locale = sa, li.localeData = la, li.max = Qn, li.min = Xn, li.parsingFlags = xa, li.set = pe, li.startOf = ya, li.subtract = Lr, li.toArray = wa, li.toObject = Ya, li.toDate = ba, li.toISOString = ea, li.inspect = ta, "undefined" != typeof Symbol && null != Symbol.for && (li[Symbol.for("nodejs.util.inspect.custom")] = function () {
    return "Moment<" + this.format() + ">";
  }), li.toJSON = Da, li.toString = Kr, li.unix = ka, li.valueOf = ga, li.creationData = Na, li.eraName = Ca, li.eraNarrow = Wa, li.eraAbbr = Pa, li.eraYear = Ra, li.year = yt, li.isLeapYear = vt, li.weekYear = za, li.isoWeekYear = Za, li.quarter = li.quarters = Ka, li.month = ut, li.daysInMonth = ht, li.week = li.weeks = Et, li.isoWeek = li.isoWeeks = Ot, li.weeksInYear = $a, li.weeksInWeekYear = Ja, li.isoWeeksInYear = Ba, li.isoWeeksInISOWeekYear = qa, li.date = ei, li.day = li.days = zt, li.weekday = Zt, li.isoWeekday = Bt, li.dayOfYear = ti, li.hour = li.hours = an, li.minute = li.minutes = ni, li.second = li.seconds = ii, li.millisecond = li.milliseconds = ai, li.utcOffset = pr, li.utc = vr, li.local = gr, li.parseZone = kr, li.hasAlignedHourOffset = br, li.isDST = wr, li.isLocal = Dr, li.isUtcOffset = Mr, li.isUtc = xr, li.isUTC = xr, li.zoneAbbr = si, li.zoneName = di, li.dates = x("dates accessor is deprecated. Use date instead.", ei), li.months = x("months accessor is deprecated. Use month instead", ut), li.years = x("years accessor is deprecated. Use year instead", yt), li.zone = x("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", yr), li.isDSTShifted = x("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", Yr);
  var fi = W.prototype;
  function _i(e, t, n, r) {
    var a = gn(),
      i = m().set(r, t);
    return a[n](i, e);
  }
  function mi(e, t, n) {
    if (u(e) && (t = e, e = void 0), e = e || "", null != t) return _i(e, t, n, "month");
    var r,
      a = [];
    for (r = 0; r < 12; r++) a[r] = _i(e, r, n, "month");
    return a;
  }
  function pi(e, t, n, r) {
    "boolean" == typeof e ? (u(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, u(t) && (n = t, t = void 0), t = t || "");
    var a,
      i = gn(),
      o = e ? i._week.dow : 0,
      s = [];
    if (null != n) return _i(t, (n + o) % 7, r, "day");
    for (a = 0; a < 7; a++) s[a] = _i(t, (a + o) % 7, r, "day");
    return s;
  }
  function yi(e, t) {
    return mi(e, t, "months");
  }
  function vi(e, t) {
    return mi(e, t, "monthsShort");
  }
  function gi(e, t, n) {
    return pi(e, t, n, "weekdays");
  }
  function ki(e, t, n) {
    return pi(e, t, n, "weekdaysShort");
  }
  function bi(e, t, n) {
    return pi(e, t, n, "weekdaysMin");
  }
  fi.calendar = R, fi.longDateFormat = B, fi.invalidDate = $, fi.ordinal = Q, fi.preparse = hi, fi.postformat = hi, fi.relativeTime = ee, fi.pastFuture = te, fi.set = T, fi.eras = Ea, fi.erasParse = Oa, fi.erasConvertYear = Ta, fi.erasAbbrRegex = Fa, fi.erasNameRegex = La, fi.erasNarrowRegex = Ha, fi.months = ot, fi.monthsShort = st, fi.monthsParse = lt, fi.monthsRegex = _t, fi.monthsShortRegex = ft, fi.week = Mt, fi.firstDayOfYear = Nt, fi.firstDayOfWeek = St, fi.weekdays = Vt, fi.weekdaysMin = At, fi.weekdaysShort = jt, fi.weekdaysParse = Gt, fi.weekdaysRegex = qt, fi.weekdaysShortRegex = $t, fi.weekdaysMinRegex = Jt, fi.isPM = nn, fi.meridiem = on, pn("en", {
    eras: [{
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    }, {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function ordinal(e) {
      var t = e % 10;
      return e + (1 === ue(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
    }
  }), n.lang = x("moment.lang is deprecated. Use moment.locale instead.", pn), n.langData = x("moment.langData is deprecated. Use moment.localeData instead.", gn);
  var wi = Math.abs;
  function Yi() {
    var e = this._data;
    return this._milliseconds = wi(this._milliseconds), this._days = wi(this._days), this._months = wi(this._months), e.milliseconds = wi(e.milliseconds), e.seconds = wi(e.seconds), e.minutes = wi(e.minutes), e.hours = wi(e.hours), e.months = wi(e.months), e.years = wi(e.years), this;
  }
  function Di(e, t, n, r) {
    var a = Er(t, n);
    return e._milliseconds += r * a._milliseconds, e._days += r * a._days, e._months += r * a._months, e._bubble();
  }
  function Mi(e, t) {
    return Di(this, e, t, 1);
  }
  function xi(e, t) {
    return Di(this, e, t, -1);
  }
  function Si(e) {
    return e < 0 ? Math.floor(e) : Math.ceil(e);
  }
  function Ni() {
    var e,
      t,
      n,
      r,
      a,
      i = this._milliseconds,
      o = this._days,
      s = this._months,
      d = this._data;
    return i >= 0 && o >= 0 && s >= 0 || i <= 0 && o <= 0 && s <= 0 || (i += 864e5 * Si(Oi(s) + o), o = 0, s = 0), d.milliseconds = i % 1e3, e = ce(i / 1e3), d.seconds = e % 60, t = ce(e / 60), d.minutes = t % 60, n = ce(t / 60), d.hours = n % 24, o += ce(n / 24), s += a = ce(Ei(o)), o -= Si(Oi(a)), r = ce(s / 12), s %= 12, d.days = o, d.months = s, d.years = r, this;
  }
  function Ei(e) {
    return 4800 * e / 146097;
  }
  function Oi(e) {
    return 146097 * e / 4800;
  }
  function Ti(e) {
    if (!this.isValid()) return NaN;
    var t,
      n,
      r = this._milliseconds;
    if ("month" === (e = ae(e)) || "quarter" === e || "year" === e) switch (t = this._days + r / 864e5, n = this._months + Ei(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    } else switch (t = this._days + Math.round(Oi(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return 24 * t + r / 36e5;
      case "minute":
        return 1440 * t + r / 6e4;
      case "second":
        return 86400 * t + r / 1e3;
      case "millisecond":
        return Math.floor(864e5 * t) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
  }
  function Ci() {
    return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * ue(this._months / 12) : NaN;
  }
  function Wi(e) {
    return function () {
      return this.as(e);
    };
  }
  var Pi = Wi("ms"),
    Ri = Wi("s"),
    Li = Wi("m"),
    Fi = Wi("h"),
    Hi = Wi("d"),
    Ui = Wi("w"),
    Vi = Wi("M"),
    ji = Wi("Q"),
    Ai = Wi("y");
  function Ii() {
    return Er(this);
  }
  function Gi(e) {
    return e = ae(e), this.isValid() ? this[e + "s"]() : NaN;
  }
  function zi(e) {
    return function () {
      return this.isValid() ? this._data[e] : NaN;
    };
  }
  var Zi = zi("milliseconds"),
    Bi = zi("seconds"),
    qi = zi("minutes"),
    $i = zi("hours"),
    Ji = zi("days"),
    Xi = zi("months"),
    Qi = zi("years");
  function Ki() {
    return ce(this.days() / 7);
  }
  var eo = Math.round,
    to = {
      ss: 44,
      s: 45,
      m: 45,
      h: 22,
      d: 26,
      w: null,
      M: 11
    };
  function no(e, t, n, r, a) {
    return a.relativeTime(t || 1, !!n, e, r);
  }
  function ro(e, t, n, r) {
    var a = Er(e).abs(),
      i = eo(a.as("s")),
      o = eo(a.as("m")),
      s = eo(a.as("h")),
      d = eo(a.as("d")),
      l = eo(a.as("M")),
      c = eo(a.as("w")),
      u = eo(a.as("y")),
      h = i <= n.ss && ["s", i] || i < n.s && ["ss", i] || o <= 1 && ["m"] || o < n.m && ["mm", o] || s <= 1 && ["h"] || s < n.h && ["hh", s] || d <= 1 && ["d"] || d < n.d && ["dd", d];
    return null != n.w && (h = h || c <= 1 && ["w"] || c < n.w && ["ww", c]), (h = h || l <= 1 && ["M"] || l < n.M && ["MM", l] || u <= 1 && ["y"] || ["yy", u])[2] = t, h[3] = +e > 0, h[4] = r, no.apply(null, h);
  }
  function ao(e) {
    return void 0 === e ? eo : "function" == typeof e && (eo = e, !0);
  }
  function io(e, t) {
    return void 0 !== to[e] && (void 0 === t ? to[e] : (to[e] = t, "s" === e && (to.ss = t - 1), !0));
  }
  function oo(e, t) {
    if (!this.isValid()) return this.localeData().invalidDate();
    var n,
      r,
      a = !1,
      i = to;
    return "object" == typeof e && (t = e, e = !1), "boolean" == typeof e && (a = e), "object" == typeof t && (i = Object.assign({}, to, t), null != t.s && null == t.ss && (i.ss = t.s - 1)), r = ro(this, !a, i, n = this.localeData()), a && (r = n.pastFuture(+this, r)), n.postformat(r);
  }
  var so = Math.abs;
  function lo(e) {
    return (e > 0) - (e < 0) || +e;
  }
  function co() {
    if (!this.isValid()) return this.localeData().invalidDate();
    var e,
      t,
      n,
      r,
      a,
      i,
      o,
      s,
      d = so(this._milliseconds) / 1e3,
      l = so(this._days),
      c = so(this._months),
      u = this.asSeconds();
    return u ? (e = ce(d / 60), t = ce(e / 60), d %= 60, e %= 60, n = ce(c / 12), c %= 12, r = d ? d.toFixed(3).replace(/\.?0+$/, "") : "", a = u < 0 ? "-" : "", i = lo(this._months) !== lo(u) ? "-" : "", o = lo(this._days) !== lo(u) ? "-" : "", s = lo(this._milliseconds) !== lo(u) ? "-" : "", a + "P" + (n ? i + n + "Y" : "") + (c ? i + c + "M" : "") + (l ? o + l + "D" : "") + (t || e || d ? "T" : "") + (t ? s + t + "H" : "") + (e ? s + e + "M" : "") + (d ? s + r + "S" : "")) : "P0D";
  }
  var uo = sr.prototype;
  return uo.isValid = ir, uo.abs = Yi, uo.add = Mi, uo.subtract = xi, uo.as = Ti, uo.asMilliseconds = Pi, uo.asSeconds = Ri, uo.asMinutes = Li, uo.asHours = Fi, uo.asDays = Hi, uo.asWeeks = Ui, uo.asMonths = Vi, uo.asQuarters = ji, uo.asYears = Ai, uo.valueOf = Ci, uo._bubble = Ni, uo.clone = Ii, uo.get = Gi, uo.milliseconds = Zi, uo.seconds = Bi, uo.minutes = qi, uo.hours = $i, uo.days = Ji, uo.weeks = Ki, uo.months = Xi, uo.years = Qi, uo.humanize = oo, uo.toISOString = co, uo.toString = co, uo.toJSON = co, uo.locale = sa, uo.localeData = la, uo.toIsoString = x("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", co), uo.lang = da, j("X", 0, 0, "unix"), j("x", 0, 0, "valueOf"), Re("x", Oe), Re("X", We), Ve("X", function (e, t, n) {
    n._d = new Date(1e3 * parseFloat(e));
  }), Ve("x", function (e, t, n) {
    n._d = new Date(ue(e));
  }),
  //! moment.js
  n.version = "2.29.4", r(Jn), n.fn = li, n.min = er, n.max = tr, n.now = nr, n.utc = m, n.unix = ci, n.months = yi, n.isDate = h, n.locale = pn, n.invalid = g, n.duration = Er, n.isMoment = D, n.weekdays = gi, n.parseZone = ui, n.localeData = gn, n.isDuration = dr, n.monthsShort = vi, n.weekdaysMin = bi, n.defineLocale = yn, n.updateLocale = vn, n.locales = kn, n.weekdaysShort = ki, n.normalizeUnits = ae, n.relativeTimeRounding = ao, n.relativeTimeThreshold = io, n.calendarFormat = Ar, n.prototype = li, n.HTML5_FMT = {
    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
    DATE: "YYYY-MM-DD",
    TIME: "HH:mm",
    TIME_SECONDS: "HH:mm:ss",
    TIME_MS: "HH:mm:ss.SSS",
    WEEK: "GGGG-[W]WW",
    MONTH: "YYYY-MM"
  }, n;
}();
var h,
  f,
  _,
  m = u.exports;
!function (e) {
  e.blue = "blue", e.green = "green", e.yellow = "yellow", e.red = "red", e.papular = "papular";
}(h || (h = {})), function (e) {
  e.fa = "fa", e.en = "en";
}(f || (f = {})), function (e) {
  e.auto = "auto", e.rightTop = "rightTop", e.rightBottom = "rightBottom", e.leftTop = "leftTop", e.leftBottom = "leftBottom";
}(_ || (_ = {}));
var p,
  y = function () {
    function e() {}
    return e.prototype.add = function (t) {
      void 0 === e.store.find(function (e) {
        return e.id === t.id;
      }) && e.store.push(t);
    }, e.prototype.clear = function () {
      e.store = [];
    }, e.store = [], e;
  }(),
  v = new y(),
  g = require("jalali-moment"),
  k = t({
    lang: "en",
    theme: h.blue,
    pick: "day",
    date: m(),
    value: m()
  }),
  b = function b(t) {
    var a = t.children,
      i = t.config,
      o = t.input,
      d = t.format,
      l = t.onChange,
      c = t.value,
      u = t.defaultValue,
      h = t.setOpen,
      f = t.closeWhenSelectADay,
      _ = "fa" === i.lang ? g : m;
    _.locale(i.lang);
    var p = n("day"),
      y = p[0],
      b = p[1],
      w = n(_()),
      Y = w[0],
      D = w[1],
      M = n(),
      x = M[0],
      S = M[1],
      N = n(void 0 !== u ? _(u.format()) : void 0),
      E = N[0],
      O = N[1];
    return r(function () {
      if (E && document.activeElement !== o.current && o) {
        if (null != o) try {
          o.current.value = E.format(d);
        } catch (e) {
          o.current.value = "Invalid Date";
        } else console.log("input is null ", o);
        f && h && h(!1);
      }
      E && D(E);
    }, [E]), r(function () {
      c && O(c);
    }, [c]), r(function () {
      var e;
      v.clear(), S(null === (e = i.events) || void 0 === e ? void 0 : e.map(function (e) {
        var t, n;
        return _s(_s({}, e), {
          date: "string" == typeof e.date ? {
            start: m(e.date).format("YYYY-MM-DD"),
            end: m(e.date).format("YYYY-MM-DD")
          } : {
            start: m(null === (t = e.date) || void 0 === t ? void 0 : t.start).format("YYYY-MM-DD"),
            end: m(null === (n = e.date) || void 0 === n ? void 0 : n.end).format("YYYY-MM-DD")
          }
        });
      }));
    }, [i.events]), e.createElement(k.Provider, {
      value: _s(_s({}, i), {
        setPick: b,
        pick: y,
        date: Y.clone(),
        setDate: function setDate(e) {
          D(e);
        },
        value: E,
        setValue: function setValue(e) {
          l && void 0 !== e && l(e.clone().locale("en")), O(e);
        },
        events: x,
        setEvents: function setEvents(e) {
          v.clear(), S(e);
        }
      })
    }, a);
  };
!function (e) {
  e.rightBottom = "right-bottom", e.leftBottom = "left-bottom", e.rightTop = "right-top", e.leftTop = "left-top";
}(p || (p = {}));
var w = require("jalali-moment"),
  Y = function Y() {
    var e = a(k),
      t = e.date.clone(),
      n = e.value,
      r = function r() {
        return "en" === e.lang ? m : w;
      };
    return {
      getMonth: function getMonth(e) {
        var n = r()(t.clone());
        return void 0 !== e && n.add(e, "M"), {
          countDay: n.daysInMonth(),
          name: n.format("MMM"),
          fullName: n.format("MMMM")
        };
      },
      maxMonth: 12,
      maxWeak: 7,
      getYear: function getYear(e) {
        return t.format("YYYY");
      },
      getMonthStartWith: function getMonthStartWith() {
        return t.startOf("month").weekday();
      },
      date: t,
      value: n,
      getMonths: function getMonths() {
        if ("fa" === e.lang) try {
          return r()().locale("fa").localeData().jMonths();
        } catch (e) {
          return console.log("react-datepicker Error:", e), ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "ابان", "اذر", "دی", "بهمن", "اسفند"];
        }
        return r()().localeData().monthsShort();
      },
      setValue: e.setValue,
      moment: r(),
      getWeakDayName: function getWeakDayName(n) {
        void 0 === n && (n = !0);
        var r = d([], n ? t.localeData().weekdaysMin() : t.localeData().weekdays(), !0);
        return "fa" === e.lang && r.unshift(r.pop()), r;
      }
    };
  },
  D = function D() {
    var e = a(k);
    return {
      convertNumbers: function convertNumbers(t) {
        if ("fa" === e.lang) {
          var n = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
          return t.toString().split("").map(function (e) {
            return n[parseInt(e)];
          }).join("");
        }
        return t;
      }
    };
  };
o(".__datepicker-dropdown-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header {\n  display: flex;\n  justify-content: space-between;\n  user-select: none;\n  align-items: center;\n  border-bottom: var(--light-border);\n  padding-bottom: 5px;\n  width: 100%;\n  margin-bottom: 10px;\n  direction: ltr !important;\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-header-text {\n  cursor: pointer;\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-header-text.__datepicker-unclickabled {\n  cursor: auto;\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-header-text:not(.__datepicker-unclickabled):hover {\n  color: var(--primary);\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-body-controller {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--corner);\n  user-select: none;\n  background-size: 100%;\n  margin: 5px 0;\n  cursor: pointer;\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-body-controller:nth-child(1) {\n  transform: rotate(0deg);\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-body-controller:nth-child(3) {\n  transform: rotate(-180deg);\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-body-controller .__datepicker-icon {\n  display: flex;\n  margin: 0 3px;\n  width: 25px;\n  justify-content: center;\n  background-color: var(--primary);\n  border-radius: var(--corner);\n}\n.__datepicker-dropdown-body .__datepicker-dropdown-body-header .__datepicker-dropdown-body-controller .__datepicker-icon svg {\n  width: 7px;\n}");
var M = function M(t) {
    var n = t.onNext,
      r = t.onPrev,
      a = t.headerText,
      i = t.children,
      o = t.onNextDouble,
      s = t.onPrevDouble,
      d = t.onClick;
    return e.createElement("div", {
      className: "__datepicker-dropdown-body"
    }, void 0 !== a && e.createElement("div", {
      className: "__datepicker-dropdown-body-header"
    }, e.createElement("div", {
      className: "__datepicker-dropdown-body-controller"
    }, s && e.createElement("div", {
      className: "__datepicker-icon",
      onClick: s
    }, e.createElement(x, null), e.createElement(x, null)), n && e.createElement("div", {
      className: "__datepicker-icon",
      onClick: r
    }, e.createElement(x, null))), e.createElement("div", {
      onClick: d,
      className: "__datepicker-dropdown-header-text ".concat(d ? "" : "__datepicker-unclickabled")
    }, a), e.createElement("div", {
      className: "__datepicker-dropdown-body-controller"
    }, o && e.createElement("div", {
      className: "__datepicker-icon",
      onClick: o
    }, e.createElement(x, null), e.createElement(x, null)), n && e.createElement("div", {
      className: "__datepicker-icon",
      onClick: n
    }, e.createElement(x, null)))), e.createElement("div", {
      className: "__datepicker-dropdown-body-content"
    }, i));
  },
  x = function x(t) {
    var n = t.color,
      r = void 0 === n ? "#FFF" : n,
      a = t.width,
      i = void 0 === a ? "25px" : a,
      o = t.height,
      s = void 0 === o ? "25px" : o;
    return e.createElement("svg", {
      width: i,
      height: s,
      viewBox: "-5 0 25 25",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("g", {
      id: "icons",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, e.createElement("g", {
      id: "ui-gambling-website-lined-icnos-casinoshunter",
      transform: "translate(-1913.000000, -158.000000)",
      fill: r,
      "fill-rule": "nonzero"
    }, e.createElement("g", {
      id: "1",
      transform: "translate(1350.000000, 120.000000)"
    }, e.createElement("path", {
      d: "M566.453517,38.569249 L577.302459,48.9938158 L577.39261,49.0748802 C577.75534,49.423454 577.968159,49.8870461 578,50.4382227 L577.998135,50.6228229 C577.968159,51.1129539 577.75534,51.576546 577.333675,51.9774469 L577.339095,51.9689832 L566.453517,62.430751 C565.663694,63.1897497 564.399001,63.1897497 563.609178,62.430751 C562.796941,61.650213 562.796941,60.3675924 563.609432,59.5868106 L573.012324,50.5572471 L563.609178,41.4129456 C562.796941,40.6324076 562.796941,39.349787 563.609178,38.569249 C564.399001,37.8102503 565.663694,37.8102503 566.453517,38.569249 Z",
      id: "left",
      transform: "translate(570.500000, 50.500000) scale(-1, 1) translate(-570.500000, -50.500000) "
    })))));
  },
  S = function S(t) {
    var n,
      r,
      i,
      o = t.day;
    t.date;
    var s = t.disabled,
      d = t.onClick,
      l = a(k),
      c = Y().moment,
      u = D().convertNumbers,
      h = function h() {
        var e;
        return null === (e = l.dayEffects) || void 0 === e ? void 0 : e.find(function (e) {
          return c(e.day).format("YYYY-MM-D") === c(o).format("YYYY-MM-D");
        });
      };
    return e.createElement("div", {
      className: function () {
        var e,
          t = "__datepicker-days";
        return o === c().format("YYYY-MM-D") && (t += " __datepicker-today"), o === (null === (e = l.value) || void 0 === e ? void 0 : e.format("YYYY-MM-D")) && (t += " __datepicker-selected"), ((null == l ? void 0 : l.disabledDate) && (null == l ? void 0 : l.disabledDate(c(o))) || s) && (t += " __datepicker-day-disabled"), t;
      }(),
      style: {
        color: h() ? null === (n = h()) || void 0 === n ? void 0 : n.color : ""
      },
      onClick: function onClick() {
        if (l.setValue) {
          if (d && d(), (null == l ? void 0 : l.disabledDate) && (null == l ? void 0 : l.disabledDate(c(o))) || s) return !1;
          l.setValue(c(o));
        }
      },
      title: null === (r = h()) || void 0 === r ? void 0 : r.title
    }, u(c(o).format("D")), h() && e.createElement("span", {
      className: "__datepicker-day-effect",
      style: {
        background: null === (i = h()) || void 0 === i ? void 0 : i.dotColor
      }
    }));
  };
o(".__datepicker-pick-day-container {\n  width: 270px;\n  margin: auto;\n}\n.__datepicker-pick-day-container .__datepicker-weak {\n  display: flex;\n  margin: 0 10px;\n  align-items: center;\n  flex-direction: row-reverse;\n  background-color: var(--primary);\n  border-radius: 5px;\n  user-select: none;\n}\n.__datepicker-pick-day-container .__datepicker-weak .__datepicker-weak-item {\n  width: 25px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 12px;\n  margin: 5px;\n}\n.__datepicker-pick-day-container .__datepicker-weak .__datepicker-weak-item.__datepicker-holiday {\n  color: var(--holiday);\n}\n.__datepicker-pick-day-container .__datepicker-pick-day {\n  display: flex;\n  margin: 5px 10px;\n  flex-wrap: wrap;\n  flex-direction: row-reverse;\n  justify-content: space-around;\n}\n.__datepicker-pick-day-container .__datepicker-pick-day .__datepicker-days {\n  width: 23px;\n  height: 23px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  border-radius: 5px;\n  margin: 5px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  user-select: none;\n  position: relative;\n}\n.__datepicker-pick-day-container .__datepicker-pick-day .__datepicker-days .__datepicker-day-effect {\n  width: 3px;\n  height: 3px;\n  border-radius: 10px;\n  position: absolute;\n  bottom: 1px;\n  left: 50%;\n  transform: translate3d(-50%, 0, 0);\n}\n.__datepicker-pick-day-container .__datepicker-pick-day .__datepicker-days:hover:not(.__datepicker-day-disabled):not(.__datepicker-today):not(.__datepicker-selected) {\n  background-color: var(--secondary);\n}\n.__datepicker-pick-day-container .__datepicker-pick-day .__datepicker-days.__datepicker-day-disabled {\n  opacity: 0.4;\n}\n.__datepicker-pick-day-container .__datepicker-pick-day .__datepicker-days.__datepicker-today {\n  color: var(--primary);\n  border: 1px solid var(--primary);\n}\n.__datepicker-pick-day-container .__datepicker-pick-day .__datepicker-days.__datepicker-selected {\n  background-color: var(--primary);\n  color: #fff;\n}");
var N = function N(t) {
    var n,
      r,
      i = t.onStep,
      o = a(k),
      s = Y(),
      d = s.getMonth,
      l = s.getYear,
      c = s.date,
      u = s.getWeakDayName,
      h = D().convertNumbers,
      f = function f(e, t) {
        return void 0 === t && (t = !1), function () {
          o.setDate && o.setDate(c.add(e ? -1 : 1, t ? "year" : "month"));
        };
      };
    return e.createElement(M, {
      onNext: f(!1),
      onNextDouble: f(!1, !0),
      onPrevDouble: f(!0, !0),
      onClick: function onClick() {
        return i(1);
      },
      headerText: "".concat(null === (n = d()) || void 0 === n ? void 0 : n.name, " ").concat(h(l())),
      onPrev: f(!0)
    }, e.createElement("div", {
      className: "__datepicker-pick-day-container"
    }, e.createElement("div", {
      className: "__datepicker-weak"
    }, u().map(function (t, n) {
      return e.createElement("div", {
        className: "__datepicker-weak-item",
        key: n
      }, t);
    })), e.createElement("div", {
      className: "__datepicker-pick-day"
    }, e.createElement(E, {
      start: !0,
      onNext: f(!0),
      onPrev: f(!0)
    }), new Array(null === (r = d()) || void 0 === r ? void 0 : r.countDay).fill("DefaultValue").map(function (t, n) {
      return e.createElement(S, {
        day: c.format("YYYY-MM-") + (n + 1),
        date: c
      });
    }), e.createElement(E, {
      start: !1,
      onNext: f(!1),
      onPrev: f(!1)
    }))));
  },
  E = function E(t) {
    var n,
      r = t.start,
      a = t.onNext,
      i = t.onPrev,
      o = Y(),
      s = o.getMonth,
      d = o.getMonthStartWith,
      l = o.date,
      c = function c(e) {
        var t,
          n = r ? ((t = s(-1)) ? t.countDay : 0) - (d() - (e + 1)) : e + 1;
        return l.clone().add(r ? -1 : 1, "month").format("YYYY-MM-") + n;
      };
    return e.createElement(e.Fragment, null, new Array(r ? d() : (n = d() + s().countDay, 7 * Math.ceil(n / 7) - n)).fill("DefaultValue").map(function (t, n) {
      return e.createElement(S, {
        onClick: r ? i : a,
        disabled: !0,
        date: l,
        day: c(n),
        key: n
      });
    }));
  };
o(".__datepicker-pick-month {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n.__datepicker-pick-month .__datepicker-pick-month-item {\n  padding: 10px 0px;\n  width: 70px;\n  margin: 5px;\n  text-align: center;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 10px;\n  border: 1px solid unset;\n}\n.__datepicker-pick-month .__datepicker-pick-month-item:hover {\n  background-color: var(--secondary);\n}\n.__datepicker-pick-month .__datepicker-pick-month-item.__datepicker-today {\n  border: 1px solid var(--primary);\n}");
var O = function O(t) {
  var n = t.onStep,
    r = Y(),
    i = r.moment,
    o = r.date,
    s = r.getYear,
    d = r.getMonths,
    l = a(k),
    c = D().convertNumbers,
    u = function u(e, t) {
      return void 0 === e && (e = !1), void 0 === t && (t = 1), function () {
        l.setDate && l.setDate(o.add(t * (e ? -1 : 1), "year"));
      };
    };
  return e.createElement(M, {
    headerText: "".concat(c(s())),
    onNext: u(!1, 1),
    onClick: function onClick() {
      return n(2);
    },
    onPrev: u(!0, 1),
    onNextDouble: u(!1, 5),
    onPrevDouble: u(!0, 5)
  }, e.createElement("div", {
    className: "__datepicker-pick-month"
  }, d().map(function (t, r) {
    return e.createElement("div", {
      key: r,
      className: "__datepicker-pick-month-item ".concat(o.format("YYYY-") + (r + 1) === i().format("YYYY-M") ? "__datepicker-today" : ""),
      onClick: function onClick() {
        l.setDate && l.setDate(null == o ? void 0 : o.set({
          month: r
        })), n(0);
      }
    }, t);
  })));
};
o(".__datepicker-loading-container {\n  position: relative;\n}\n.__datepicker-loading-container .__datepicker-loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--corner);\n}\n.__datepicker-loading-container .__datepicker-loading .__datepicker-loading-spin {\n  width: 48px;\n  height: 48px;\n  display: inline-block;\n  background: #FFF;\n  position: relative;\n  box-sizing: border-box;\n  animation: flipX 1s linear infinite;\n}\n\n@keyframes flipX {\n  0% {\n    transform: perspective(200px) rotateX(0deg) rotateY(0deg);\n  }\n  50% {\n    transform: perspective(200px) rotateX(-180deg) rotateY(0deg);\n  }\n  100% {\n    transform: perspective(200px) rotateX(-180deg) rotateY(-180deg);\n  }\n}");
var T = function T(t) {
  var n = t.children,
    r = t.loading,
    a = t.spinnerComponent;
  return e.createElement("div", {
    className: "__datepicker-loading-container"
  }, e.createElement("div", {
    className: "__datepicker-loading-content"
  }, n), r && e.createElement(e.Fragment, null, a || e.createElement("div", {
    className: "__datepicker-loading"
  }, e.createElement("span", {
    className: "__datepicker-loading-spin"
  }))));
};
o(".__datepicker-pick-year {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.__datepicker-pick-year .__datepicker-year {\n  padding: 5px 0px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  margin-bottom: 10px;\n  width: 45px;\n  text-align: center;\n}\n.__datepicker-pick-year .__datepicker-year:hover {\n  border: 1px solid var(--primary);\n  border-radius: var(--corner);\n}\n.__datepicker-pick-year .__datepicker-year.__datepicker-controller {\n  opacity: 0.4;\n}");
var C = function C(t) {
    var n = t.onStep,
      r = Y().date,
      i = a(k),
      o = D().convertNumbers,
      s = function s(e) {
        return function () {
          i.setDate && (e ? i.setDate(r.add(-19, "year")) : i.setDate(r.add(19, "year")));
        };
      };
    return e.createElement(M, {
      onNext: s(!1),
      onPrev: s(!0),
      headerText: "".concat(o(r.year() - 9), " - ").concat(o(r.year() + 10))
    }, e.createElement("div", {
      className: "__datepicker-pick-year"
    }, [-9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (t, a) {
      return e.createElement("div", {
        key: a,
        className: "__datepicker-year",
        onClick: function onClick() {
          i.setDate && (i.setDate(r.add(t, "year")), n(1));
        }
      }, o(r.year() + t));
    })));
  },
  W = function W(t) {
    var i = t.open,
      o = t.footer,
      s = t.loading,
      d = t.spinnerComponent,
      l = t.refMain,
      c = t.adjustPosition,
      u = t.setOpen,
      h = n(0),
      f = h[0],
      _ = h[1],
      m = Y(),
      y = m.moment,
      v = m.setValue,
      g = function (e, t) {
        var i = n(),
          o = i[0],
          s = i[1],
          d = n(),
          l = d[0],
          c = d[1];
        a(k);
        var u = function u() {
          var t = e.current.getBoundingClientRect(),
            n = window.innerHeight,
            r = window.innerWidth;
          window.scrollX, t.top < 0 ? c("fix-top") : c(void 0), t.right > r - t.left ? t.top <= n - t.bottom ? s(p.rightBottom) : s(p.rightTop) : t.top < n - t.bottom ? s(p.leftBottom) : s(p.leftTop);
        };
        return r(function () {
          return e && t && (window.addEventListener("scroll", u), window.addEventListener("resize", u)), function () {
            window.removeEventListener("scroll", u), window.removeEventListener("resize", u);
          };
        }, [t]), {
          position: o,
          fix: l
        };
      }(l, i),
      b = g.fix,
      w = g.position;
    return e.createElement(e.Fragment, null, "modal" === c && e.createElement("div", {
      className: "__datepicker-modal-bg",
      onClick: function onClick() {
        return u(!1);
      }
    }), e.createElement("div", {
      className: "__datepicker-dropdown ".concat(i ? "__datepicker-dropdown-active" : "", " ").concat("auto" !== c ? "modal" === c ? "__datepicker-modal" : c : w, " ").concat(b || "")
    }, e.createElement(T, {
      loading: s,
      spinnerComponent: d
    }, e.createElement(e.Fragment, null, 0 === f && e.createElement(N, {
      onStep: _
    }), 1 === f && e.createElement(O, {
      onStep: _
    }), 2 === f && e.createElement(C, {
      onStep: _
    }), o && e.createElement("div", {
      className: "__datepicker-dropdown-footer"
    }, o(y, v))))));
  };
o(".__datepicker {\n  position: relative;\n}\n.__datepicker input {\n  transition: unset !important;\n}\n.__datepicker * {\n  --holiday: rgba(234, 43, 9, 0.829);\n  --light-border: 1px solid rgba(0, 0, 0, 0.125);\n  --corner: 5px;\n  --background: #fff;\n}\n.__datepicker.__datepicker-theme-blue * {\n  --primary: rgb(0, 102, 255);\n  --secondary: rgb(55, 135, 255);\n}\n.__datepicker.__datepicker-theme-red * {\n  --primary: rgb(255, 55, 0);\n  --secondary: rgb(255, 91, 46);\n}\n.__datepicker.__datepicker-theme-papular * {\n  --primary: rgb(140, 6, 218);\n  --secondary: rgba(0, 0, 0, 0.3);\n}\n.__datepicker.__datepicker-theme-orange * {\n  --primary: rgb(255, 102, 0);\n  --secondary: rgba(0, 0, 0, 0.3);\n}\n.__datepicker.__datepicker-theme-yellow * {\n  --primary: rgb(215, 160, 8);\n  --secondary: rgba(0, 0, 0, 0.3);\n}\n.__datepicker.__datepicker-theme-green * {\n  --primary: rgb(91, 203, 6);\n  --secondary: rgb(103, 223, 12);\n}\n.__datepicker.__datepicker-theme-mode-dark * {\n  --background: rgb(51, 51, 51);\n  --color: #fff;\n  --light-border: 1px solid rgba(0, 0, 0, 0.8);\n}");
var P = require("jalali-moment"),
  R = function R(t) {
    var a = t.theme,
      o = void 0 === a ? h.blue : a,
      s = t.lang,
      d = void 0 === s ? f.fa : s,
      l = t.input,
      c = void 0 === l ? e.createElement("input", {
        placeholder: "datepicker"
      }) : l,
      u = t.format,
      _ = void 0 === u ? "YYYY/MM/DD" : u,
      p = t.footer,
      y = t.onChange,
      v = t.value,
      g = t.defaultValue,
      k = t.modeTheme,
      w = void 0 === k ? "light" : k,
      Y = t.dayEffects,
      D = t.disabled,
      M = t.disabledDate,
      x = t.loading,
      S = t.closeWhenSelectADay,
      N = void 0 === S || S,
      E = t.onOpen,
      O = t.spinnerComponent,
      T = t.adjustPosition,
      C = void 0 === T ? "auto" : T,
      R = t.name,
      L = "fa" === d ? P : m,
      F = n(!1),
      H = F[0],
      U = F[1],
      V = n(),
      j = V[0],
      A = V[1],
      I = i(null),
      G = n(),
      z = G[0],
      Z = G[1],
      B = i(null);
    return function (e, t) {
      r(function () {
        function n(n) {
          "function" != typeof e.current && "object" != typeof e.current || e.current && !e.current.contains(n.target) && t();
        }
        return document.addEventListener("mousedown", n), function () {
          document.removeEventListener("mousedown", n);
        };
      }, [e]);
    }(I, function () {
      U(!1);
    }), r(function () {
      var e = L(v);
      "fa" === d && (e = L.from(v, "en")), v && v !== j && A(e.locale(d));
    }, [v]), r(function () {
      H && E && E();
    }, [H]), r(function () {
      Z(null !== I.current ? I.current.querySelector("input") : void 0);
    }, [I]), e.createElement(b, {
      config: {
        lang: d,
        theme: o,
        disabledDate: M,
        dayEffects: Y
      },
      format: _,
      setOpen: U,
      onChange: y,
      value: j,
      defaultValue: g,
      closeWhenSelectADay: N,
      input: B
    }, e.createElement("div", {
      className: "__datepicker __datepicker-theme-".concat(o, " __datepicker-theme-mode-").concat(w, " "),
      ref: I
    }, e.createElement("div", {
      className: "__datepicker-input"
    }, void 0 === z && e.createElement("div", {
      style: {
        display: "none"
      }
    }, c), e.createElement("input", {
      ref: B,
      className: null == z ? void 0 : z.getAttribute("class"),
      placeholder: null == z ? void 0 : z.getAttribute("placeholder"),
      onFocus: function onFocus() {
        return U(!0);
      },
      autoComplete: "disabled",
      disabled: D,
      onChange: function onChange(e) {
        var t;
        "string" == typeof e ? t = L(e) : void 0 !== e.target && (t = L(e.target.value)), t && t.isValid() && ("en" === d || t.year() >= 1e3) && A(t);
      },
      name: R || (null == z ? void 0 : z.getAttribute("name"))
    })), H && e.createElement(W, {
      open: H,
      footer: p,
      loading: x,
      spinnerComponent: O,
      adjustPosition: C,
      refMain: I,
      setOpen: U
    })));
  },
  L = {
    fa: {
      Today: "امروز"
    }
  };
o(".__calendar-body {\n  width: var(--width);\n  height: 100%;\n}\n.__calendar-body .__calendar-header {\n  display: flex;\n  justify-content: space-between;\n}\n.__calendar-body .__calendar-header .__calender-header-children {\n  width: 130px;\n}\n.__calendar-body .__calendar-header .__calender-header-controllers {\n  display: flex;\n  align-items: center;\n  direction: ltr;\n  gap: 20px;\n}\n.__calendar-body .__calendar-header .__calender-header-controllers .__calendar-controller {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgb(59, 59, 59);\n  user-select: none;\n  border: var(--border);\n  width: 25px;\n  border-radius: 3px;\n  cursor: pointer;\n  height: 25px;\n}\n.__calendar-body .__calendar-header .__calender-header-controllers .__calendar-controller:nth-last-child(1) {\n  transform: rotate(180deg);\n}\n.__calendar-body .__calendar-header .__calender-header-controllers .__calendar-controller:hover {\n  border-color: var(--primary);\n  color: #fff;\n}\n.__calendar-body .__calendar-header .__calender-header-controllers .__calendar-header-today {\n  cursor: pointer;\n}\n.__calendar-body .__calender-content {\n  height: 100%;\n}\n.__calendar-body table th {\n  text-align: center;\n}");
var F = function F(t) {
  var n,
    r = t.children,
    i = t.onNextClick,
    o = t.onPrevClick,
    s = t.header,
    d = t.side,
    l = t.onTodayClick,
    c = (n = a(k), {
      _t: function _t(e, t) {
        var r = L[n.lang];
        return r && (e = r[e] ? r[e] : e), t && t.forEach(function (t, n) {
          e.replace("{".concat(n, "}"), t);
        }), e;
      }
    })._t;
  return e.createElement("div", {
    className: "__calendar-body"
  }, e.createElement("div", {
    className: "__calendar-header"
  }, e.createElement("div", {
    className: "__calender-header-controllers"
  }, e.createElement("div", {
    className: "__calender-header-children"
  }, s), e.createElement("div", {
    className: "__calendar-controller",
    onClick: o
  }, e.createElement(x, {
    color: "rgba(59, 59, 59,0.8)",
    height: "15px",
    width: "15px"
  })), e.createElement("div", {
    className: "__calendar-header-today",
    onClick: l
  }, c("Today")), e.createElement("div", {
    className: "__calendar-controller",
    onClick: i
  }, e.createElement(x, {
    color: "rgba(59, 59, 59,0.8)",
    height: "15px",
    width: "15px"
  }))), d && e.createElement("div", {
    className: "__calender-right-side"
  }, d)), e.createElement("div", {
    className: "__calender-content"
  }, r));
};
o(".__datepicker-table {\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  width: 100%;\n  height: 100%;\n  table-layout: fixed;\n}");
var H = function H(t) {
  var n = t.children,
    r = t.className;
  return e.createElement("table", {
    className: "__datepicker-table ".concat(r)
  }, n);
};
o('.__calender-table-td {\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  z-index: 1;\n}\n.__calender-table-td .__calendar-table-td-body {\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n}\n.__calender-table-td .__calendar-table-td-body .__calendar-table-td-body-date {\n  position: absolute;\n  top: 0px;\n  right: 5px;\n  font-size: 11px;\n  user-select: none;\n}\n.__calender-table-td .__calendar-table-td-body:hover > .__calendar-table-td-body-date {\n  color: #000;\n}\n.__calender-table-td .__calendar-table-td-body .__calendar-table-td-body-events {\n  flex-grow: 1;\n  flex: 1;\n  min-height: 15vh;\n  margin-top: 20px;\n  position: relative;\n}\n.__calender-table-td .__calendar-table-td-body .__calendar-table-td-body-events .__calendar-table-td-body-events-item {\n  display: flex;\n  align-items: center;\n  margin: 1px;\n  font-size: 10px;\n  padding: 0 3px;\n  border-radius: 3px;\n  position: absolute;\n  background-color: #001f3f;\n  z-index: 10;\n  user-select: none;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  height: 25px;\n  color: #fff;\n}\n.__calender-table-td .__calendar-table-td-body .__calendar-table-td-body-events .__calendar-table-td-body-events-item .__calendar-table-td-body-events-item-circle {\n  min-width: 3px;\n  min-height: 3px;\n  border-radius: 10px;\n  background: #f2f2f2;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.__calender-table-td .__calendar-table-td-body .__calendar-table-td-body-events .__calendar-table-td-body-events-item.hover {\n  opacity: 0.95;\n  border: 1px solid black;\n}\n.__calender-table-td .__calendar-table-td-body .__calendar-table-td-body-events .__calendar-table-td-body-events-item.hide {\n  opacity: 0 !important;\n  z-index: 15;\n}\n.__calender-table-td.__calender-past {\n  background: url("./past-day.png") repeat;\n  background-size: 50px;\n}\n.__calender-table-td.__calender-past .__calendar-table-td-body-date {\n  color: #aaa;\n}\n.__calender-table-td.__calender-disabled-cell {\n  background-color: var(--disable-day-color);\n}\n.__calender-table-td.__calender-today {\n  outline: 1px solid var(--primary);\n  background-color: #e6f7ff;\n  z-index: 2;\n}\n.__calender-table-td.__calender-table-td-drag-hover, .__calender-table-td:hover {\n  background-color: #ffffcc;\n}\n.__calender-table-td.__calender-table-td-clickable {\n  cursor: pointer;\n}\n\n.__calender-month-header {\n  text-align: center;\n  margin-bottom: 10px;\n}\n.__calender-month-header .__calender-header-title {\n  font-size: 22px;\n}\n.__calender-month-header .__calender-header-subtitle {\n  color: rgb(123, 123, 123);\n}');
var U = function U(t) {
    var o,
      d,
      l = t.index,
      c = t.item,
      u = t.cellIndexInWeek,
      h = t.date,
      f = t.cellWith;
    t.key;
    var _ = t.setParentHeight,
      p = a(k);
    h = m(h).locale("en").format("YYYY-MM-DD");
    var y = 0 !== u && c.date.start !== h,
      v = i(null),
      g = n({
        update: !0
      })[1],
      b = "item-e-".concat(c.id),
      w = function w(e) {
        return function (t) {
          document.querySelectorAll(".".concat(b)).forEach(function (t) {
            e ? t.classList.remove("hover") : t.classList.add("hover");
          });
        };
      };
    return r(function () {
      null !== v.current && g({
        update: !0
      });
    }, []), e.createElement("div", {
      draggable: void 0 !== p.onDropEvent,
      onDrag: function onDrag(e) {
        e.target.style.opacity = 0;
      },
      onDragStart: function onDragStart(e) {
        e.dataTransfer.setData("text", c.id.toString());
      },
      onDragEnd: function onDragEnd(e) {
        e.target.style.opacity = 1;
      },
      ref: v,
      key: "range-event-".concat(l),
      className: "__calendar-table-td-body-events-item ".concat(null == c ? void 0 : c.className, " ").concat(y ? "hide" : "", " ").concat(b),
      style: _s(_s({}, null == c ? void 0 : c.style), function () {
        var e, t;
        if (null !== v.current) {
          var n = {
            width: "calc(".concat((t = m(c.date.end).diff(m(h), "days") + 1, (7 - u > t ? t : 7 - u) * f + "vw"), " - 5px)"),
            top: ((null === (e = v.current) || void 0 === e ? void 0 : e.offsetHeight) + 5) * (void 0 !== (null == c ? void 0 : c.priority) ? c.priority : l)
          };
          return _ && _((v.current.offsetHeight + 10 + n.top) / window.innerHeight * 100), n;
        }
        return {};
      }()),
      onClick: null === (o = p.onClickEvent) || void 0 === o ? void 0 : o.bind(undefined, c),
      onMouseEnter: w(!1),
      onMouseLeave: w(!0),
      onDoubleClick: null === (d = p.onDoubleClickEvent) || void 0 === d ? void 0 : d.bind(undefined, c)
    }, c.icon ? c.icon : e.createElement("div", {
      className: "__calendar-table-td-body-events-item-circle",
      style: {
        background: c.dotColor
      }
    }), c.title);
  },
  V = function V(t) {
    var n,
      r = t.date,
      a = t.cellIndexInWeek,
      o = t.cellWith,
      s = t.events,
      d = "__calendar-table-events-".concat(r),
      l = i(null);
    return e.createElement("div", {
      className: "__calendar-table-td-body-events ".concat(d),
      ref: l
    }, null === (n = null == s ? void 0 : s.sort(function (e, t) {
      return (null == e ? void 0 : e.priority) && (null == t ? void 0 : t.priority) ? (null == e ? void 0 : e.priority) - (null == t ? void 0 : t.priority) : -1;
    })) || void 0 === n ? void 0 : n.map(function (t, n) {
      return e.createElement(U, {
        index: n,
        item: t,
        date: r,
        cellIndexInWeek: a,
        cellWith: o,
        key: "event-".concat(t.id, "-").concat(t.priority, "-").concat(t.date),
        setParentHeight: function setParentHeight(e) {
          null !== l.current && e > 15 && (l.current.style.minHeight = "".concat(e, "vh"));
        }
      });
    }));
  },
  j = function j(e) {
    var t = a(k),
      i = n(),
      o = i[0],
      l = i[1],
      c = function c(e) {
        for (var t = new Set(e.map(function (e) {
            return e.priority;
          })), n = 0; t.has(n);) n++;
        return n;
      };
    return r(function () {
      var n = t.events ? d([], t.events, !0) : [],
        r = null == n ? void 0 : n.filter(function (t) {
          return function (t, n) {
            void 0 === n && (n = e);
            var r = m(n),
              a = m(t.date.start).locale("en").format("YYYY-MM-DD"),
              i = m(t.date.end).locale("en").format("YYYY-MM-DD");
            return r.locale("en").format("YYYY-MM-DD") >= a && r.locale("en").format("YYYY-MM-DD") <= i;
          }(t);
        }).map(function (e) {
          var t = y.store.find(function (t) {
            return t.id === e.id;
          });
          return _s(_s({}, e), {
            priority: null == t ? void 0 : t.priority
          });
        }).sort(function (e, t) {
          return void 0 !== e.priority && void 0 !== t.priority ? e.priority - t.priority : 1;
        });
      r.length > 0 ? (r.forEach(function (e, t) {
        var n = y.store.find(function (t) {
          return t.id === e.id;
        });
        void 0 === n ? (v.add({
          id: e.id,
          priority: c(r)
        }), r[t].priority = c(r)) : e.priority = null == n ? void 0 : n.priority;
      }), l(d([], r, !0))) : l([]);
    }, [t.events]), {
      events: o
    };
  },
  A = function A(t) {
    var o,
      l = t.date,
      c = t.disabled,
      u = t.onClick,
      h = t.cellIndexInWeek,
      f = Y().moment,
      _ = a(k),
      p = j(f(l).locale("en").format("YYYY-MM-DD")).events,
      y = i(null),
      g = n({
        update: !0
      })[1],
      b = _.onDay ? _.onDay(f(l).locale("en").format("YYYY-MM-DD")) : {},
      w = document.querySelector(".__calender-table-td");
    return r(function () {
      var e = function e() {
        g({
          update: !0
        });
      };
      return window.addEventListener("resize", e), function () {
        window.removeEventListener("resize", e);
      };
    }, []), e.createElement("td", {
      ref: y,
      onClick: function onClick() {
        u && u(), _.onDateClick && _.onDateClick(f(l).locale("en").format("YYYY-MM-DD"));
      },
      className: "__calender-table-td ".concat((o = [], c && o.push("__calender-disabled-cell"), f(l).format("YYYY-MM-DD") === f().format("YYYY-MM-DD") && o.push("__calender-today"), f(l).format("YYYY-MM-DD") < f().format("YYYY-MM-DD") && o.push("__calender-past"), _.onDateClick && o.push("__calender-table-td-clickable"), b && b.className && o.push(b.className), o.join(" "))),
      onDragOver: function onDragOver(e) {
        e.preventDefault();
      },
      onDrop: function onDrop(e) {
        e.preventDefault(), e.stopPropagation();
        var t = f(l).locale("en").format("YYYY-MM-DD"),
          n = e.dataTransfer.getData("text");
        v.clear(), _.setEvents(function (e) {
          var r = d([], e, !0),
            a = e.findIndex(function (e) {
              return e.id === parseInt(n);
            });
          if (-1 !== a) {
            var i = r[a],
              o = m(t, "YYYY-MM-DD").locale("en").format("YYYY-MM-DD"),
              l = m(i.date.end, "YYYY-MM-DD").diff(m(i.date.start, "YYYY-MM-DD"), "days");
            if (i.date.start = o, i.date.end = m(o).locale("en").add(l, "days").format("YYYY-MM-DD"), "Invalid date" === i.date.end || "Invalid date" === i.date.start) return console.log("calendar error", "the date is invalid!!"), e;
            _.onDropEvent && _.onDropEvent(i);
            var c = r.splice(a, 1);
            r.push(c[0]);
          }
          return r.map(function (e) {
            return _s(_s({}, e), {
              priority: void 0
            });
          });
        }), y.current.classList.remove("__calender-table-td-drag-hover");
      }
    }, e.createElement("div", {
      className: "__calendar-table-td-body"
    }, e.createElement("div", {
      className: "__calendar-table-td-body-date"
    }, f(l).format("DD MMMM")), e.createElement(V, {
      date: f(l).locale("en").format("YYYY-MM-DD"),
      cellIndexInWeek: h,
      cellWith: w ? w.offsetWidth / window.innerWidth * 100 : 0,
      events: p
    })));
  },
  I = function I() {
    var t,
      n = Y(),
      r = n.getWeakDayName,
      i = n.getMonth,
      o = n.getMonthStartWith,
      s = n.moment,
      d = n.date,
      l = n.getYear,
      c = D().convertNumbers,
      u = a(k),
      h = Math.ceil((i().countDay + o()) / 7),
      f = function f(e, t) {
        return void 0 === t && (t = !1), function () {
          if (u.setDate) {
            var n = d.add(e ? -1 : 1, t ? "year" : "month");
            u.setDate(n);
            var r = n.clone();
            u.onMonthChange && u.onMonthChange(r.startOf("month").locale("en").format("YYYY-MM-DD"), r.endOf("month").locale("en").format("YYYY-MM-DD"));
          }
        };
      };
    return e.createElement(F, {
      onNextClick: f(!0),
      onPrevClick: f(!1),
      onTodayClick: function onTodayClick() {
        u.setDate && u.setDate(s());
      },
      header: e.createElement("div", {
        className: "__calender-month-header"
      }, e.createElement("div", {
        className: "__calender-header-title"
      }, c(l()), " ", null === (t = i()) || void 0 === t ? void 0 : t.fullName))
    }, e.createElement(H, null, e.createElement("thead", null, e.createElement("tr", null, r(!1).map(function (t, n) {
      return e.createElement("th", {
        key: n
      }, t);
    }))), e.createElement("tbody", null, new Array(h).fill("w").map(function (t, n) {
      var r = 7 * n - o();
      return e.createElement("tr", null, 0 === n && e.createElement(G, null), new Array(7).fill("d").map(function (t, n) {
        var a = n + 1 + r;
        if (a <= i().countDay && a > 0) return e.createElement(A, {
          date: d.format("YYYY-MM-") + a,
          key: "".concat(n, "-").concat(d.format("YYYY-MM-") + a),
          cellIndexInWeek: n
        });
      }), n === h - 1 && e.createElement(z, null));
    }), e.createElement("tr", null))));
  },
  G = function G() {
    var t = Y(),
      n = t.getMonthStartWith,
      r = t.getMonth,
      a = t.date,
      i = function i(e) {
        var t,
          i = ((t = r(-1)) ? t.countDay : 0) - (n() - (e + 1));
        return a.clone().add(-1, "month").format("YYYY-MM-") + i;
      };
    return e.createElement(e.Fragment, null, new Array(n()).fill("d").map(function (t, n) {
      return e.createElement(A, {
        date: i(n),
        disabled: !0,
        cellIndexInWeek: n
      });
    }));
  },
  z = function z() {
    var t = Y(),
      n = t.getMonthStartWith,
      r = t.getMonth,
      a = t.date,
      i = function i() {
        var e = n() + r().countDay;
        return 7 * Math.ceil(e / 7) - e;
      },
      o = function o(e) {
        var t = e + 1;
        return a.clone().add(1, "month").format("YYYY-MM-") + t;
      };
    return e.createElement(e.Fragment, null, new Array(i()).fill("d").map(function (t, n) {
      return e.createElement(A, {
        date: o(n),
        disabled: !0,
        cellIndexInWeek: 7 - i() + n
      });
    }));
  };
o(".__calendar {\n  width: 100%;\n  height: 100%;\n}\n.__calendar * {\n  --border: 1px solid rgba(0, 0, 0, 0.125);\n  --disable-day-color: rgb(232,237,241);\n}\n.__calendar.__calendar-theme-blue * {\n  --primary: rgb(0, 102, 255);\n  --secondary: rgb(55, 135, 255);\n}\n.__calendar.__calendar-theme-red * {\n  --primary: rgb(255, 55, 0);\n  --secondary: rgb(255, 91, 46);\n}\n.__calendar.__calendar-theme-papular * {\n  --primary: rgb(140, 6, 218);\n  --secondary: rgba(0, 0, 0, 0.3);\n}\n.__calendar.__calendar-theme-orange * {\n  --primary: rgb(255, 102, 0);\n  --secondary: rgba(0, 0, 0, 0.3);\n}\n.__calendar.__calendar-theme-yellow * {\n  --primary: rgb(215, 160, 8);\n  --secondary: rgba(0, 0, 0, 0.3);\n}\n.__calendar.__calendar-theme-green * {\n  --primary: rgb(91, 203, 6);\n  --secondary: rgb(103, 223, 12);\n}\n.__calendar.__calendar-theme-mode-dark * {\n  --background: rgb(51, 51, 51);\n  --color: #fff;\n  --light-border: 1px solid rgba(0, 0, 0, 0.8);\n}");
var Z = function Z(t) {
  var n = t.lang,
    r = void 0 === n ? "en" : n,
    a = t.theme,
    i = void 0 === a ? "blue" : a,
    o = t.events,
    s = t.onDropEvent,
    d = t.onClickEvent,
    l = t.onDoubleClickEvent,
    c = t.style,
    u = t.onDateClick,
    h = t.onDay,
    f = t.onMonthChange;
  return e.createElement(b, {
    config: {
      lang: r,
      theme: i,
      events: o,
      onDropEvent: s,
      onClickEvent: d,
      onDoubleClickEvent: l,
      onDateClick: u,
      onDay: h,
      onMonthChange: f
    }
  }, e.createElement("div", {
    className: "__calendar __calendar-theme-".concat(i),
    style: c
  }, e.createElement(I, null)));
};
export { Z as Calendar, R as Datepicker };